import { Component, ElementRef, ViewChild, ViewEncapsulation , OnInit, Renderer, Input, NgZone } from '@angular/core';
import { IonicPage,ModalController, NavController, NavParams,AlertController,Platform, LoadingController, PopoverController } from 'ionic-angular';
import { ElectronService } from 'ngx-electron';
import { AuthService } from '../../providers/auth-service'
import { CompaniasProvider } from '../../providers/companias/companias'
import { MensajeProvider } from '../../providers/mensaje/mensaje'
import { CajaProvider } from '../../providers/caja/caja'
import { MesasProvider } from '../../providers/mesas/mesas'
import { PushProvider } from '../../providers/push/push'
import { GESTION_PEDIDOS_SALON, MODO_DESCONECTADO, NUBE_AWS, RUTA_MODO_DESCONECTADO, URL_SERVICIOS_LOCALES } from "../../config/url.servicio"
import { Turnos } from '../../models/turnos/turnos.models';
import { UsuariosProvider } from '../../providers/usuarios/usuarios';
import { InAppBrowser } from '@ionic-native/in-app-browser';
import { Store } from '@ngrx/store';
import { AppState } from '../../app/app.reducer';
// import * as JsBarcode from 'jsbarcode';
import { Observable } from 'rxjs';
import { SetTurnosAction, UnsetTurnosAction } from './state/turnos/turnos.accions';
import * as uuid from 'uuid';
import { manipularPedido} from './state/productos/productos.actions';
import { MensajerosMensajerosPage } from '../mensajeros-mensajeros/mensajeros-mensajeros';
import { UtilsProvider } from '../../providers/utils/utils';
import { ImpresoraBluePage } from '../impresora-blue/impresora-blue';
import * as fromClienteSelect from '../cliente-select/state/cliente-select/cliente-select-accions'
import * as fromUsuarioSelect from './state/usuarioselect/usuarioselect.accions'
import * as fromClienteSelectAll from './state/clienteselect/clienteselect.accions'
import * as fromEstados from './state/estados/estados.accions'
import { valueDisplay } from '../../models/valueDisplay.model';
import { SetTurnosAsignadosAction, UnsetTurnosAsignadosAction } from './state/turnos-asignados/turnos-asignados-accions';
import { ClienteSelectPage } from '../cliente-select/cliente-select';
import { TurnosPage } from '../turnos/turnos';
import { PagoPage } from '../pago/pago';
import { DinamicaPage } from '../dinamica/dinamica';
import { DinamicaGruposPorProductosPage } from '../dinamica-grupos-por-productos/dinamica-grupos-por-productos';
import { DevolverVentaPage } from '../devolver-venta/devolver-venta';
import { Storage } from '@ionic/storage'
import  'rxjs/add/observable/interval';
import 'rxjs/add/operator/filter';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/map';
import { Clienteselect } from '../../models/clienteselect/clienteselect.models';
import { ParametrosGeneralesRedux } from '../../providers/redux/parametrosgenerales/parametrosgenerales';
import { GestionPedidosRedux } from '../../providers/redux/gestionpedidos/gestionpedidos';
import { TurnosRedux } from '../../providers/redux/turnos/turnos';
import { ClienteSelectRedux } from '../../providers/redux/clienteselect/clienteselect';
import { UtilsRedux } from '../../providers/redux/utils/utils'
import { Estados } from '../../models/estados/estados.models';
import { trigger, state, style, transition, animate} from '@angular/animations';
import { GestionarPedidoPage } from '../gestionar-pedido/gestionar-pedido';
import { clientes } from '../../models/clientes';
import { ClientesProvider } from '../../providers/clientes/clientes';
import { ProductosProvider } from '../../providers/productos/productos';
import { UsuarioSelectPage } from '../usuario-select/usuario-select';
import { Subscription } from 'rxjs/Subscription';
import 'rxjs/add/observable/from';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/operator/map';
import { GestionporproductoPage } from '../gestionporproducto/gestionporproducto';
import { ImprimirPage } from '../imprimir/imprimir';
import { ImprimirGlobalComponent } from '../imprimir-global/imprimir-global';
import { UsuarioPedidoSalonComponent } from '../../components/usuariopedidosalon/usuariopedidosalon';
import { fromEvent } from 'rxjs/observable/fromEvent';
import { merge } from 'rxjs/observable/merge';
import { timer } from 'rxjs/observable/timer';
import { switchMap, debounceTime, distinctUntilChanged } from 'rxjs/operators';

declare var webkitSpeechRecognition: any;

@IonicPage()
@Component({
  selector: 'page-meseromesero',
  templateUrl: 'meseromesero.html',
  encapsulation: ViewEncapsulation.None,
  providers: [ AuthService,CompaniasProvider,MensajeProvider,
    CajaProvider,MesasProvider,ElectronService,PushProvider,InAppBrowser,ParametrosGeneralesRedux,
    GestionPedidosRedux, TurnosRedux, ClienteSelectRedux, UtilsRedux],
    animations: [
      trigger('openClose', [
          state('collapsed, void', style({height:'0px'})),
          state('expanded', style({height:'*'})),
          transition('collapsed <=> expanded',[animate(300,style({height:'*'})),
              animate(300)])

      ])
  ]
})
export class MeseromeseroPage implements OnInit {
  title;
  nombrecaja: string;
  listaMuestra = [];
  listaMuestraOcupadas = [];
  actualizar:any= [{
    valor:0
  }]
  datatitle = []
  valortitle: string = "meseros"

  listaGruposProductos = []
  listaGruposProductosMesa = []
  listaProductos = []
  listaCentroDeCostosGestion = []
  listaProductosMesa = []
  clienteGenerico
  clienteGenericoMesa

  nombreFiltroGrupo
  filtroGruposActivo: boolean = false
  filtrogruposProductosId

  listaProductosSeleccionados = []
  valorTotalVenta = 0
  valorTotalProductos = 0
  valorTotalImpuestos = 0
  price = 0
  valorTotalDevolver = 0
  datosAdicionalesArrayMesero = []
  realizandoUnaVenta: boolean = false

  numeromesa
  numeromesaMostrar: any = ""

  clienteId = []
  domicilio: string = 'N'
  domicilioCheck: boolean = false;
  actualizando: boolean = false
  nombreCompaniaHeader: any = ""
  nombreCargoHeader: any = ""
  GestionPedidosSalon: any = GESTION_PEDIDOS_SALON;
  descripcion: string = '';
  usuariosid;
  permiteEliminarPedido: boolean = false;
  mesaCambio = []
  mesasId;
  mesasIdMesaCambio;
  companiasId;
  token: string = "";
  bluetooth: boolean = false;
  manejaImpresoPorDefecto: boolean = true;
  buscar = '';
  allItems: any;
  cargando: boolean = false;
  turno = 'Turno';
  turnos: Turnos;
  turnosId;
  turnosAsignados : any = [];
  turnosArray = [];
  pedido = 'Pedido';
  clientesSelect = [];
  usuarioSelect = [];
  usuarioId = [];
  manejaCodigoDeBarras: boolean = false;
  timerCodigoBarra;
  @ViewChild('cantidadafnprueba') cantidadafnprueba;
  creaProductoRapidoDesdeCaja: boolean = false;
  public codigoBarra:any = '';
  cantidadRealCodigoBarra:number = 0
  public formState: string = 'collapsed'
  public formStatebool:boolean= false
  listaGrupos
  @ViewChild('canvasOld') canvasElement : ElementRef;
  codigoProducto: string = '';
  nombreProducto: string = '';
  valorVenta: number = 0;
  valorImpuesto:number=0
  costo:number=0
  gruposProductosId: string = '';
  productoId: string = '';
  devolverVenta: boolean = false;
  listaClientes = [];
  valoresCliente: string = '';
  valoresUsuario: string = '';
  nombreTurno: string = ""
  estado: Estados =  {
    clienteSelect: false,
    usuarioSelect: false,
    grupos: true,
    productos: false,
    pedidos: false,
    mesas: false,
    response: false
  }

  segId: string = 'products'
  estadoFormCrearCliente: boolean = false
  estadoGestionPedidos: boolean = false
  telefonoClienteRapido: string = ""
  nombreClienteRapido: string = ""
  direccionClienteRapido: string = ""
  mesaSeleccionada: string = ""
  formaPagoSeleccionada: string = 'O'
  CheckPorcentajeServicio:boolean = false
  subscriptionProductosSeleccionados: Subscription;
  reconocimientoActivo: boolean = false;
  recognition: any;
  grabando: boolean = false;
  botonDeshabilitado: boolean = false;
  cantidadImpresionesEnCaja: string = "1"
  controlaImpresorasEnRed: boolean = false;
  ip:string = '';
  sobreGiroEnLosProductos:boolean = false
  tiempoParaBloqueoClavePedidosSalon:number=0
  claveEnPedidosSalon:boolean = false
  recorrerVal=[]
  permiteIngresar:boolean = false
  usuariosIdIngresoConClave
  actividadSub: Subscription;
  nombreUsuario:any=''
  constructor(
              public alertControllers: AlertController,
              public servicioMesas: MesasProvider,
              public storage: Storage,
              public servicio: CajaProvider,
              public servicioCompania: CompaniasProvider,
              public auth: AuthService,
              public platform: Platform,
              public serviciUsuario: UsuariosProvider,
              public push: PushProvider,
              public modalControllers: ModalController,
              public navCtrl: NavController,
              private iab: InAppBrowser,
              private store: Store<AppState>,
              public utilsMensajero:UtilsProvider,
              public utilsParametrosGeneralesRedux: ParametrosGeneralesRedux,
              public utilsGestionPedidosRedux: GestionPedidosRedux,
              public utilsTurnosRedux: TurnosRedux,
              public utilsClienteSelectRedux: ClienteSelectRedux,
              public utilsRedux: UtilsRedux,
              public loadingController: LoadingController,
              public renderer: Renderer,
              public providerClientes: ClientesProvider,
              public servicioProductos:ProductosProvider,
              public navParams: NavParams,
              private _electronService: ElectronService,
              private popoverCtrl: PopoverController,
              private ngZone: NgZone


) {
  this.permiteIngresar = this.navParams.get('permiteIngresar');
  this.usuariosIdIngresoConClave = this.navParams.get('usuariosId')
  this.nombreUsuario = this.navParams.get('nombreUsuario')
  if(!MODO_DESCONECTADO){
      this.actualizarestados(this.estado)
      this.buscarDatosIniciales();
      this.buscarTurnosAsignados();
      this.resetStore();
      this.actualizar['valor'] = true;
      this.buscarDatoslocales();
      this.buscarClientes();
      this.buscarUsuarios();
      this.actualizarestados(this.estado)
  } else {
    this.actualizarestados(this.estado)
    this.storage.get('nombreCargo').then((val) => {
      this.nombreCargoHeader = val
    });
    this.servicioCompania.devolverVarios(['companiasId','usuariosId', 'nombreCargo'])
    .then((val)=>{
      if(val){
        let companiasId = val['companiasId'];
        let usuariosId = val['usuariosId'];
        this.cargarTurno(companiasId, usuariosId, 1, '');
        this.elect()
       }

      this.turnosAsignados.push({
        turno: '',
        numeromesa: '',
        codigo: '',
        domicilio: 'No'
      });
       this.store.dispatch(new UnsetTurnosAsignadosAction());
       this.store.dispatch(new SetTurnosAsignadosAction(this.turnosAsignados));
       this.llenarTurnoAsignadosRedux()
       this.resetStore();
       this.actualizar['valor'] = true;
       this.actualizarestados(this.estado)
    })

  }
}

ngOnInit() {
  this.presentLoading().then(()=> {

  })
  this.servicio.abrirPagina('CajaPage')
  .then((valor)=>{
    if(!valor) {
      // this.navCtrl.setRoot('HomePage');
    }
  }).catch(() =>{
      // this.navCtrl.setRoot('HomePage');
  })
}


setupSubscription(listaProductosSeleccionados: any) {
  const objectObservable = Observable.from([listaProductosSeleccionados]);

  this.subscriptionProductosSeleccionados = objectObservable
    .distinctUntilChanged()
    .map((newObject: any) => {
      if(this.CheckPorcentajeServicio) {
        this.cambiarCheckPorcentajeSubscription(newObject)
      }
    })
    .subscribe();
}

async buscarDatosIniciales() {
  this.storage.get('nombreCargo').then((val) => {
    this.nombreCargoHeader = val
  });
  let buscarParametrosGeneralesStore: any = await this.utilsParametrosGeneralesRedux.buscarParametrosGeneralesStore()
  if(buscarParametrosGeneralesStore !== null && buscarParametrosGeneralesStore.parametrosGenerales !== null) {
    this.companiasId = buscarParametrosGeneralesStore.parametrosGenerales[0][0].companiasId
    this.usuariosid = buscarParametrosGeneralesStore.parametrosGenerales[0][0].usuariosid
    this.bluetooth = buscarParametrosGeneralesStore.parametrosGenerales[0][0].bluetooth
    this.manejaImpresoPorDefecto = buscarParametrosGeneralesStore.parametrosGenerales[0][0].manejaImpresoPorDefecto
    this.manejaCodigoDeBarras = buscarParametrosGeneralesStore.parametrosGenerales[0][0].manejaCodigoDeBarras
    this.creaProductoRapidoDesdeCaja = buscarParametrosGeneralesStore.parametrosGenerales[0][0].creaProductoRapidoDesdeCaja
    this.devolverVenta = buscarParametrosGeneralesStore.parametrosGenerales[0][0].devolverVenta
    this.nombreCompaniaHeader = buscarParametrosGeneralesStore.parametrosGenerales[0][0].nombreUsuario
    this.controlaImpresorasEnRed = buscarParametrosGeneralesStore.parametrosGenerales[0][0].controlaImpresorasEnRed
    this.ip = buscarParametrosGeneralesStore.parametrosGenerales[0][0].ip
    let administrador = buscarParametrosGeneralesStore.parametrosGenerales[1][0].administrador

    if (administrador){
      this.permiteEliminarPedido = true
    }
  } else {
    this.servicioCompania.devolverVarios(['companiasId','usuariosId', 'nombreCargo'])
    .then((val)=>{
      if(val){
        let companiasId = val['companiasId'];
        let usuariosId = val['usuariosId'];
        let nombreUsuario = val['nombreUsuario'];
        this.utilsParametrosGeneralesRedux.buscarParametrosGeneralesRedux(companiasId, usuariosId, nombreUsuario)
        this.buscarParametrosGeneralesBD()
      }
    })
  }
  this.cargarTurno(this.companiasId, this.usuariosid, 1, '');
  this.cargarGruposIniciales(this.companiasId)
}

async buscarParametrosGeneralesBD() {
  let buscarParametrosGeneralesStore: any = await this.utilsParametrosGeneralesRedux.buscarParametrosGeneralesStore()
  if(buscarParametrosGeneralesStore !== null && buscarParametrosGeneralesStore.parametrosGenerales !== null) {
    // this.utilsMensajero.mensajeMuestro('Advertencia','Debe salir de la página y volver a entrar, no es necesario cerrar la sesión','Advertencia')
    console.log('recargar valores')
    return
  }
  this.companiasId = buscarParametrosGeneralesStore.parametrosGenerales[0][0].companiasId
  this.usuariosid = buscarParametrosGeneralesStore.parametrosGenerales[0][0].usuariosid
  this.bluetooth = buscarParametrosGeneralesStore.parametrosGenerales[0][0].bluetooth
  this.manejaImpresoPorDefecto = buscarParametrosGeneralesStore.parametrosGenerales[0][0].manejaImpresoPorDefecto
  this.manejaCodigoDeBarras = buscarParametrosGeneralesStore.parametrosGenerales[0][0].manejaCodigoDeBarras
  this.creaProductoRapidoDesdeCaja = buscarParametrosGeneralesStore.parametrosGenerales[0][0].creaProductoRapidoDesdeCaja
  this.devolverVenta = buscarParametrosGeneralesStore.parametrosGenerales[0][0].devolverVenta
  this.nombreCompaniaHeader = buscarParametrosGeneralesStore.parametrosGenerales[0][0].nombreUsuario
  this.controlaImpresorasEnRed = buscarParametrosGeneralesStore.parametrosGenerales[0][0].controlaImpresorasEnRed
  this.ip = buscarParametrosGeneralesStore.parametrosGenerales[0][0].ip;
  let administrador = buscarParametrosGeneralesStore.parametrosGenerales[1][0].administrador
  if (administrador){
    this.permiteEliminarPedido = true
  }
}


async cargarGruposIniciales(companiasId: any) {
  this.servicio.buscarGruposProductosParaCajaComandas(companiasId).subscribe((item: any)=> {
    let res = JSON.parse(item['_body']).data
    this.listaGruposProductos = res[0]
    this.listaProductos = res[1]
    this.clienteGenericoMesa = res[2]
    this.listaClientes = res[2]
    this.listaCentroDeCostosGestion = res[5]
  })

}
loadMoreData(event:any) {
  console.log(event)
}

  toggleFormCrearCliente(){
    this.estadoFormCrearCliente = !this.estadoFormCrearCliente
  }
  toggleGestionPedidos(){
    this.estadoGestionPedidos = !this.estadoGestionPedidos
  }
  labelCrearCliente(){
      return (!this.estadoFormCrearCliente) ? 'Mostrar Crear Cliente Rápido' : 'Ocultar Crear Cliente Rápido'
  }
  iconCrarCliente(){
    return (!this.estadoFormCrearCliente) ? 'arrow-dropright-circle' : 'arrow-dropleft-circle'
  }

  goToEvent() {

  }

  presetActionSheet() {
    console.log('ev')
  }

  presentPopover(ev: any) {
    console.log('ev', ev)
  }

  deleteItem(id: string) {
    console.log('id', id)
  }
  remove(id: string) {
    console.log('id', id)
  }
  add(id: string) {
    console.log('id', id)
  }
  segmentChanged(ev:any) {
    this.segId = ev._value
    console.log(ev._value)
  }
  async presentLoading() {
    // const loading = await this.loadingController.create({
    //   message: 'Please Wait ..',

    // });
    // await loading.present();
  }
  notificationModal(ev: any) {

  }

  presentModal(ev: any) {
  }




  searchCodigoBarra(cantidadafn:any,i:any){
    setTimeout(() => {
   if(cantidadafn['value'] !== '') {
       this.codigoBarra = cantidadafn['value'];
   } else {
       cantidadafn['value'] = '';
       return;
   }
   if(this.codigoBarra === '') {
      return false;
   }
   this.storage.get('companiasId').then((val) => {
           this.servicioCompania.buscarCodigoBarra(val,this.codigoBarra)
           .debounceTime(3000)
           .subscribe((data)=>{
               if(data[0].length){
                   const valores = data[0][0];
                   if(this.codigoBarra !== ''){
                     this.codigoProducto = this.codigoBarra
                   }
                   this.codigoBarra = '';

               } else {
                   this.formState = 'expanded';
                   this.formStatebool = true;
               }
           },(error)=>{
           });
      });
   }, 1000);
 }

 startTimerCodigoDeBarras(){
  if(this.manejaCodigoDeBarras){
    this.cantidadafnprueba.nativeElement.focus();
  }
}

 canvasNoDefinido(){
}

canvasElementcodigo(codigo){
  if(this.manejaCodigoDeBarras){
      // this.canvasElement.nativeElement.style ="display:block"
      // JsBarcode(this.canvasElement.nativeElement, codigo);
  }
}

toggleForm(){
    this.formState = (this.formState == 'collapsed') ? 'expanded' : 'collapsed'
    this.formStatebool = !this.formStatebool
    if (this.formState == 'collapsed') {
      // this.canvasElement.nativeElement.style = 'display:none';
    }
}
label(){
    return (this.formState == 'collapsed') ? 'Agregar' : 'Ocultar'
}
icon(){
  return (this.formState == 'collapsed') ? 'arrow-dropright-circle' : 'arrow-dropleft-circle'
}

async mensajeVacio(mensaje: any) {
  const modal = await this.llamarModal(undefined,undefined,mensaje,true);
  await modal.present();
}

guardarProducto() {
  if(this.codigoProducto !=="" && this.nombreProducto !== "" && this.codigoBarra !== "" && this.valorVenta !== 0){
  this.storage.get('companiasId').then((val) => {
  const datosProducto: any = {
      codigoProducto: this.codigoProducto,
      nombreProducto: this.nombreProducto,
      valorVenta: this.valorVenta,
      existenciasMinimas:0,
      existenciasActuales: 0,
      visualizaEnCaja: true,
      controlaEnInventario: true,
      tipoImpuesto:'I',
      valorImpuesto: Number(this.valorImpuesto),
      /** afnarqui cuadrar */
      centroDeCostosId: 1,
      imagen:'https://res.cloudinary.com/drqk6qzo7/image/upload/v1533160332/gk3qijtsmugz7mm08kts.png',
      codigoBarra:this.codigoBarra,
      companiasId:val,
      costo:Number(this.costo),
      queHago: "I",
      nombreTabla: "productos",
      name: "dataDynamicCrud"
    }
  this.servicio.guardarTodo(datosProducto)
    .subscribe(
      res => {
          this.mensajeVacio('Producto guardado..');
          this.productoId = res[0]['productosId']
          this.guardarGruposProductos(this.productoId)
          this.limpiarProducto()
          this.buscarDatos();

          this.startTimerCodigoDeBarras()
      },
      err => {
          this.startTimerCodigoDeBarras()
          this.mensajeVacio('No se pudo guardar el producto, intente luego');
          this.limpiarProducto()
      }
    )


  })
} else {
  this.mensajeVacio(`No se pudo guardar el producto existen campos obligatorios`)
  this.limpiarProducto()
}
}

guardarGruposProductos(productosId:any) {
  let datosGruposProductos: any = {
    gruposProductosId: this.gruposProductosId,
    tipoProducto:  "P",
    productoId:  productosId,
    queHago: "I",
    nombreTabla: "productosPorGrupos",
    name: "dataDynamicCrud"
  }
  this.storage.get('companiasId').then((val) => {
    datosGruposProductos['companiasId'] = val
    this.guardarProductosPorGrupos(datosGruposProductos)
 });
}

guardarProductosPorGrupos(datos) {
  this.servicio.guardarTodo(datos)
  .subscribe(
    res => {
        this.limpiarProducto()
        this.buscarDatos();
    },
    err => {
    this.mensajeVacio(`No se pudo guardar el producto, intente luego`)
    this.limpiarProducto()
  }
  )
}

limpiarProducto() {
  this.codigoBarra =""
  this.nombreProducto = ""
  this.codigoProducto = ""
  this.valorVenta = 0
  this.costo = 0
  this.descripcion = '';
  if(this.manejaCodigoDeBarras){
    this.canvasNoDefinido()
    // this.canvasElement.nativeElement.style ="display:none";
  }
  this.formState = 'collapsed'
  this.formStatebool = false
  this.productoId = '';
  this.cantidadRealCodigoBarra = 0
  if(this.manejaCodigoDeBarras) {
    this.startTimerCodigoDeBarras()
  }
}

 cargarGrupos() {
  this.listaGrupos = []

  this.storage.get('companiasId').then((val) => {
   const companiasId = val
   this.servicio.buscarGruposCompaniasId(companiasId)
  .subscribe(
    res => {
      this.listaGrupos = res[0]
    },
    err => {
      this.mensajeVacio('error No se pudieron listar los grupos, intente luego')
    }
  );
})

}

 aumentarUnProductoCodigoBarra(item:any){
  if(this.sobreGiroEnLosProductos) {
    let existenciasActuales = Number(item.existenciasActuales)
    let cantidadActual = 0
    let nuevaCantidadProductos = this.listaProductosSeleccionados.filter((value)=> value.productosId == item.productosId)
    if(nuevaCantidadProductos.length>0) {item['cantidad']
      cantidadActual = nuevaCantidadProductos[0].cantidad
      cantidadActual = cantidadActual + 1
    } else {
      cantidadActual = item['cantidad'] !== undefined ? Number(item['cantidad']): 1
      cantidadActual = item['cantidad'] === undefined  ? 1 : cantidadActual + 1
    }

    if(existenciasActuales<=0 || existenciasActuales < cantidadActual) {
      this.utilsMensajero.mensajeMuestro('Producto sin existencia','El producto no tiene existencias para vender','warning')
      return
    }
  }
  this.cantidadRealCodigoBarra += 1
  const codigoBarra  = Number(item['codigoBarra'])
  const productosId  = Number(item['productosId'])
  let existeProducto = 0
  let posicion = 0
  let existeProductoUnico = 0
  let posicionUnico = 0
  this.realizandoUnaVenta = true
  let itemselectvalorProducto = 0;
  let itemselectvalorImpuesto = 0;
  let itemcantidad = 0;

  for(let i =0;i <this.listaProductos.length;i++){
      if(this.listaProductos[i].productosId == productosId){
        existeProductoUnico = 1
        posicionUnico = i
        item['valorImpuestoCalculo'] = this.listaProductos[i].valorImpuestoCalculo
        item['valorImpuesto'] = this.listaProductos[i].valorImpuesto
        item['valorProducto'] = this.listaProductos[i].valorProducto
        item['valorImpuesto'] = this.listaProductos[i].valorImpuesto
        i = this.listaProductos.length + 1
      }
    }

  for(let i =0;i <this.listaProductosSeleccionados.length;i++){
    if(this.listaProductosSeleccionados[i].productosId == productosId){

      itemselectvalorProducto = this.listaProductosSeleccionados[i].valorProducto
      itemselectvalorImpuesto = this.listaProductosSeleccionados[i].valorImpuesto
      itemcantidad = this.listaProductosSeleccionados[i].cantidad + 1
      existeProducto = 1
      posicion = i
      i = this.listaProductosSeleccionados.length + 1
    }
  }

  if(existeProducto == 0){

      item['cantidad'] = 1
      this.listaProductosSeleccionados.push(item)
      item['tipoProducto'] = 'P'
      let valorTotalVentaNum = 0
      valorTotalVentaNum = Number(this.valorTotalVenta) +  Number(item['valorVenta'])
      this.valorTotalVenta = valorTotalVentaNum

      let valorTotalProductosNum = 0
      item['valorProducto'] = Number(item['valorVenta']) - Number(item['valorImpuesto'])
      valorTotalProductosNum = Number(this.valorTotalProductos) +  Number(item['valorProducto'])
      this.valorTotalProductos = valorTotalProductosNum
      let valorTotalImpuestosNum =  0
      valorTotalImpuestosNum =Number(this.valorTotalImpuestos) +  Number(item['valorImpuesto'])
      this.valorTotalImpuestos = valorTotalImpuestosNum

      this.valorTotalVenta = valorTotalVentaNum
      this.valorTotalProductos = valorTotalProductosNum
      this.valorTotalImpuestos = valorTotalImpuestosNum



   }
  else{

    let nuevaCantidad  = Number(itemcantidad)
    this.listaProductosSeleccionados[posicion]['cantidad'] = nuevaCantidad
    item['tipoProducto'] = 'P'
    let valorTotalVentaNum = 0
    valorTotalVentaNum = Number(this.valorTotalVenta) +  Number(item['valorVenta'])
    this.valorTotalVenta = valorTotalVentaNum

    let valorTotalProductosNum = 0
    item['valorProducto'] = Number(item['valorVenta']) - Number(item['valorImpuesto'])
    valorTotalProductosNum = Number(this.valorTotalProductos) +  Number(itemselectvalorProducto)
    this.valorTotalProductos = valorTotalProductosNum
    let valorTotalImpuestosNum =  0
    valorTotalImpuestosNum =Number(this.valorTotalImpuestos) +  Number(itemselectvalorImpuesto)
    this.valorTotalImpuestos = valorTotalImpuestosNum

    this.valorTotalVenta = valorTotalVentaNum
    this.valorTotalProductos = valorTotalProductosNum
    this.valorTotalImpuestos = valorTotalImpuestosNum

    if(item['cantidad']==0){
        return
    }else{
      this.cantidadRealCodigoBarra = 0
    }

  }
}

  startTimerCodigoDeBarraUnico(){
    if(this.manejaCodigoDeBarras){
     this.timerCodigoBarra = Observable.interval(3000).subscribe( x => {
           this.cantidadafnprueba.nativeElement.focus();
           this.timerCodigoBarra.unsubscribe();
     })
   }
 }

  ionViewWillLeave() {
    this.buscarClientes();
    }
    buscarClientes() {
      this.storage.get('companiasId').then((val) => {
         this.servicio.buscarClientesAll(val)
        .subscribe((data: any)=> {
          let clienteJson = NUBE_AWS ? JSON.parse(data['_body']) : data[0]
          let clienteResponse = NUBE_AWS ? clienteJson.data[0] : data[0]
          this.clientesSelect = clienteResponse
          this.listaClientes = clienteResponse
          let cliente: Clienteselect[] = clienteResponse
          const actionClienteSelect = new fromClienteSelectAll.SetClienteselectAction(cliente);
          this.store.dispatch(new fromClienteSelectAll.UnsetClienteselectAction())
          this.store.dispatch(actionClienteSelect);
        },
         error=> {
           console.log(error);
         })
        });
    }

    buscarUsuarios() {
      this.storage.get('companiasId').then((val) => {
        this.serviciUsuario.buscarUsuarioPorEmpresa(val)
       .subscribe((data: any)=> {
         let usuarioJson = NUBE_AWS ? JSON.parse(data['_body']) : data[0]
         let usuarioResponse = NUBE_AWS ? usuarioJson.data[0] : data[0]
         this.usuarioSelect = usuarioResponse
         let usuario: any = usuarioResponse
         this.store.dispatch(new fromUsuarioSelect.CargarValueDisplaySuccessActions(usuario))
       },
        error=> {
          console.log(error);
        })
       });
    }
  async buscarMesasPorCompanias(idMesa: any) {
    let buscarParametrosGeneralesStore: any = await this.utilsParametrosGeneralesRedux.buscarParametrosGeneralesStore()
    this.companiasId = buscarParametrosGeneralesStore.parametrosGenerales[0][0].companiasId
    let administrador = buscarParametrosGeneralesStore.parametrosGenerales[1][0].administrador
    // if (administrador){
      this.permiteEliminarPedido = true
      this.servicioMesas.buscarListamesasPorCompania(this.companiasId)
        .subscribe((valores: any) => {
          this.turnos.numeroPedido = idMesa ;
          this.turnosArray[0]['numeroPedido'] = idMesa;
          this.turnosArray[0]['numeroPedidoMostrar'] = 'Pedido:' + idMesa;
          const dataIdMesa = this.buscarPosicionMesa(valores, idMesa)
          valores.data[0].splice(dataIdMesa[0].id, 1)
          this.mesaCambio = valores.data[0]
        }, (error) => {
          console.log(error)
        })
    // }
  }

  buscarPosicionMesa(valores: any, idMesa: any) {

    let data = []
    let valorComparar = Number(idMesa)
    let valor = NUBE_AWS ? valores.data[0] : valores[0]
    for (let k = 0; k < valor.length; k++) {
      if (valor[k].mesas === valorComparar) {

        data.push({
          id: k,
        })

      }
    }

    return data

  }



  searchSimple(cantidadafnSimple: any, item, index) {
    setTimeout(() => {


      if (Number(cantidadafnSimple['_value']) == 0 || isNaN(cantidadafnSimple['_value'])) {
        return
      }


      let cantidad = Number(cantidadafnSimple['_value'])

      let nuevaCantidad = Number(cantidad)

      index = this.buscarIndex(item, index)
      let cantidadOld = this.listaProductosSeleccionados[index]['cantidad']
      let valorImpuesto = this.listaProductosSeleccionados[index]['valorImpuesto']
      let valorProducto = this.listaProductosSeleccionados[index]['valorProducto']
      let valorVenta = this.listaProductosSeleccionados[index]['valorVenta']

      this.valorTotalImpuestos -= (valorImpuesto * cantidadOld)
      this.valorTotalProductos -= (valorProducto * cantidadOld)
      this.valorTotalVenta -= (valorVenta * cantidadOld)
      this.listaProductosSeleccionados[index]['cantidad'] = nuevaCantidad

      this.actualizarReal(item, index)
      let valorTotalVentaNum = 0

      valorTotalVentaNum = Number(this.valorTotalVenta) + (Number(item['valorVenta']) * nuevaCantidad)
      this.valorTotalVenta = valorTotalVentaNum

      let valorTotalProductosNum = 0
      valorTotalProductosNum = Number(this.valorTotalProductos) + (Number(item['valorProducto']) * nuevaCantidad)
      this.valorTotalProductos = valorTotalProductosNum
      let valorTotalImpuestosNum = 0
      valorTotalImpuestosNum = Number(this.valorTotalImpuestos) + (Number(item['valorImpuesto']) * nuevaCantidad)
      this.valorTotalImpuestos = valorTotalImpuestosNum

      item = {}
      cantidadafnSimple['_value'] = ''


    }, 1000)
  }


  buscarIndex(item: any, index: any) {
    let id = Number(index)

    let tipoProducto = item['tipoProducto']
    let productosId = item['productosId']
    let indexNuevo = 0



    for (let k = 0; k < this.listaProductosSeleccionados.length; k++) {
      if (this.listaProductosSeleccionados[k].productosId == productosId && this.listaProductosSeleccionados[k].tipoProducto == tipoProducto) {
        indexNuevo = k
        k = this.listaProductosSeleccionados.length + 1
      }
    }


    return indexNuevo
  }

  imprimirAndroidMesero(item: string): void {
    this.storage.get('companiasId').then((companiasId) => {
    this.servicio.imprimirComandaBlue(item, companiasId)
        .subscribe((data: any) => {
           let items = JSON.parse(data['_body']).data
            this.modalPrintCualquieraBlutoothAndroid(items)

        }, (error)=> {
          ;
    });
  })
  }

  modalPrintCualquieraBlutoothAndroid(item:any){

    this.guardarBlutoothAndroid(item)
}

  modalPrintCualquieraBlutooth(item:any){

    this.guardarBlutooth(item)
}
guardarBlutooth(item: any) {
  const datos = {
    "nombre": JSON.stringify(item)
    }
  this.descargarArchivo(datos)
}

guardarBlutoothAndroid(item: any) {
  const datos = {
    "nombre": JSON.stringify(item)
    }
  this.descargarArchivoAndroid(datos)
}

  imprimirMesero(values: string) {
    if(this.platform.is('android') || this.platform.is('ios')){
      let codigo = values
      this.imprimirAndroidMesero(codigo)
    }else{
    this.storage.get('companiasId').then((val) => {
      this.servicio.imprimirComandasMesasPorGestion(values, val)
        .subscribe((data) => {
          let dataJson = JSON.parse(data['_body'])
          let responseJson = dataJson
          this.reemprimirReciboMesasGestion(responseJson.data)
        },
          error => {
            console.log(error)
          })
    })
   }
  }

  imprimirMeseroTodaLaFactura(values: string) {
    if(this.platform.is('android') || this.platform.is('ios')){
      let codigo = values
      this.imprimirAndroidMeseroTodaLaFactura(codigo)
    }else{
    this.storage.get('companiasId').then((val) => {
      this.servicio.imprimirComandaBlue(values, val)
        .subscribe((data) => {
          let dataJson = JSON.parse(data['_body'])
          let responseJson = dataJson
          this.reemprimirReciboMesasGestion(responseJson.data)
        },
          error => {
            console.log(error)
          })
    })
   }
  }

  imprimirAndroidMeseroTodaLaFactura(item: string): void {
    this.storage.get('companiasId').then((companiasId) => {
    this.servicio.imprimirComandaBlue(item, companiasId)
        .subscribe((data: any) => {
           let items = JSON.parse(data['_body']).data
            this.modalPrintCualquieraBlutoothAndroid(items)

        }, (error)=> {
          ;
    });
  })
  }

  mostrarMensajeGeneral(mensaje) {
    let recibo = ''
    if (mensaje && mensaje[0] && mensaje[0][0]) {
      const mensajes = mensaje[0]
      // tslint:disable-next-line: prefer-for-of
      // for (let index: any = 0; index < mensajes.length; index++) {
      //   recibo += mensajes[index]['reciboCaja'] + '\n'
      // }
      for (let index:any = 0; index < mensajes.length; index++) {
        //recibo +=  '   ' + mensaje[index]['reciboCaja'] + '\n'
        const textoRecibo = mensajes[index]['reciboCaja'];

        // Comandos ESC/POS para negrita y tamaño de fuente
        const negritaOn = '\x1b\x45\x01'; // Activar negrita
        const negritaOff = '\x1b\x45\x00'; // Desactivar negrita
        const tamañoGrandeNotanto = '\x1b\x21\x10'; // Cambiar a tamaño de fuente grande
        const tamañoGrande = '\x1b\x21\x20'; // Cambiar a tamaño de fuente grande
        const tamañoNormal = '\x1b\x21\x00'; // Cambiar a tamaño de fuente normal

        if (textoRecibo.includes("TOTAL A PAGAR")) {
          recibo += negritaOn + tamañoGrande + '   ' + textoRecibo + '\n' + tamañoNormal + negritaOff;
        } else {
          if(textoRecibo.includes("CAMBIO")) {
            recibo += negritaOn + tamañoGrandeNotanto + '   ' + textoRecibo + '\n' + tamañoNormal + negritaOff;
          } else {
            recibo += '   ' + textoRecibo + '\n';
          }
        }
      }
    }
    this.servicio.imprimirRecibo(recibo).subscribe(
      res => {

      },
      err => {

        if (this.platform.is('android') || this.platform.is('ios')) {

          this.mostrarMensajeExito(' ' + recibo)
        } else {
        }

      }
    )


  }

  mostrarMensajeExito(mensaje) {
  }



  enviarMensaje(nombre: any, data: any) {
  }


  buscarDatos(mesaGestionada?: number) {
    this.storage.get('companiasId').then((val) => {
      this.servicioMesas.buscarMesasPorCompania(val)
        .subscribe(
          (res: any) => {
            if(NUBE_AWS) {
             res =  res['data']
            }
            if (res[0] !== undefined) {
            this.listaMuestra = [];
            for (var k = 0; k < res[0].length; k++) {
              this.listaMuestra.push({
                left: res[0][k].leftt,
                width: res[0][k].width,
                top: res[0][k].topp,
                height: res[0][k].height,
                id: res[0][k].id,
                color: '#d96153',
                Uuid: res[0][k].Uuid,
                name: 'dataDynamicCrud',
                queHago: 'I',
                nombreTabla: 'mesas',
                sinAsignar: false,
                'colorOriginal':'#d96153',
                numeroPersona:res[0][k].numeroPersona,
                incluirServicio:res[0][k].incluirServicio,
                formaDePago:res[0][k].formaDePago
              });
              }
            }
            if (res[1] !== undefined) {
              for (var k = 0; k < res[1].length; k++) {
                this.listaMuestra.push({
                  'left': res[1][k].leftt,
                  'width': res[1][k].width,
                  'top': res[1][k].topp,
                  'height': res[1][k].height,
                  'id': res[1][k].id,
                  'color':'#4e6b66',
                  'Uuid': res[1][k].Uuid,
                  'name': "dataDynamicCrud",
                  'queHago': "I",
                  'nombreTabla': "mesas",
                  sinAsignar: true,
                  'colorOriginal':'#4e6b66',
                  numeroPersona:res[1][k].numeroPersona,
                  incluirServicio:res[1][k].incluirServicio,
                  formaDePago:res[1][k].formaDePago
                });
            }
          }
            },
        error => {
            console.log(error)
          }
        );
    })
    this.actualizar['valor'] = true
    this.datatitle['valor'] = true
    this.domicilioCheck = false;
  }

  cambiarColorMesaSeleccionada(id:any) {
    let result = this.listaMuestra.filter((item)=> item.id === id)
    this.mesaSeleccionada = result[0] === undefined ? '' : result[0].id
  }

  async sacarMensajeBotonionChange(event:any, values:any) {
    if(!MODO_DESCONECTADO){
    this.limpiarCliente()
    this.limpiarUsuario()
    if(values.sinAsignar) {
      this.mesaSeleccionada = values.id
      this.asignarNuevoTurno()
    }
    this.listaProductosSeleccionados = [];
    await this.sacarMensajeBoton(event, 'false','N', event);
    this.estadoGestionPedidos = false;
    if(values.incluirServicio == 'S'){
      this.CheckPorcentajeServicio = true
    }
   } else {

    this.limpiarCliente()
    this.limpiarUsuario()
    if(values.sinAsignar) {
      this.mesaSeleccionada = values.id
      this.asignarNuevoTurnoDesconect()
    }
    this.listaProductosSeleccionados = [];
    await this.sacarMensajeBoton(event, 'false','N', event);
    this.estadoGestionPedidos = false;
    if(values.incluirServicio == 'S'){
      this.CheckPorcentajeServicio = true
    }

   }
  }
  async sacarMensajeBoton(id: any, queHago: string, domicilio: string, item: any) {
    this.descripcion = '';
    if(item.sinAsignar) {
      await this.validarAsignacionDePedido(id,item);
    }

    this.buscarMesasPorCompanias(id)
    this.domicilio = domicilio;
    this.actualizarValoresDesdeMesas(id, queHago,this.turnos.turno);
    this.cambiarColorMesaSeleccionada(id)
  }

  mostrarMensajes(mensaje, advertencia) {
  }

  async buscarGruposProductosParaCaja(id: any) {
    const valorid = id;
    await this.traerDatosGuardados(valorid)
    let gestionPedidos: any = await this.utilsGestionPedidosRedux.buscarGruposProductosGestionPedidosStore()

    //this.listaGruposProductos = gestionPedidos !== undefined && gestionPedidos.gestionpedidos === null && gestionPedidos.gestionpedidos[0] == undefined ? this.listaGruposProductos : gestionPedidos.gestionpedidos[0]
    if (gestionPedidos && gestionPedidos.gestionpedidos !== null && gestionPedidos.gestionpedidos[0] !== undefined) {
      this.listaGruposProductos = gestionPedidos.gestionpedidos[0];
    } else {
      this.listaGruposProductos = gestionPedidos !== null ? this.listaGruposProductos : null;
    }

    if (gestionPedidos && gestionPedidos.gestionpedidos !== null && gestionPedidos.gestionpedidos[1] !== undefined) {
      this.listaProductos = gestionPedidos.gestionpedidos[1];
    } else {
      this.listaProductos = gestionPedidos !== null ? this.listaProductos : null;
    }

    if (gestionPedidos && gestionPedidos.gestionpedidos !== null && gestionPedidos.gestionpedidos[2] !== undefined) {
      this.clienteGenericoMesa = gestionPedidos.gestionpedidos[2];
      this.listaClientes = gestionPedidos.gestionpedidos[2];
    } else {
      this.clienteGenericoMesa = gestionPedidos !== null ? this.clienteGenericoMesa : null;
      this.listaClientes = gestionPedidos !== null ? this.listaClientes : null;
    }
  }

  valoresImagenes(res: any) {
    if (this.platform.is('android') || this.platform.is('ios')) {
      this.listaGruposProductos = NUBE_AWS ? res[0] : res[0]
      this.listaProductos = NUBE_AWS ? res[1] : res[1]
    } else {
      this.listaGruposProductos = NUBE_AWS ? res[0] : res[0]
      this.listaProductos = NUBE_AWS ? res[1] : res[1]
    }
  }

  async traerDatosGuardados(id: any) {
    let mesa = id
    this.storage.get('companiasId').then((val) => {
      this.servicio.buscarComandasMesero(mesa, val)
        .subscribe((val: any) => {
          if(NUBE_AWS) {
            val = JSON.parse(val['_body']).data[0]
          }
          this.listaProductosSeleccionados = []
          if (val.length > 0) {
            this.store.dispatch(new UnsetTurnosAction());
            // tslint:disable-next-line: prefer-for-of
            for (let k = 0; k < val.length; k++) {
              if (mesa == val[k].numeromesa) {
                this.listaProductosSeleccionados.push(val[k])
                this.valorTotalImpuestos += Number(val[k].valorImpuesto)
                this.valorTotalVenta += Number(val[k].valorTotalVenta)
                this.valorTotalProductos += Number(val[k].valorProducto)
                this.valorTotalDevolver = Number(val[k].valorTotalVenta)
                this.valorTotalVenta = Number(val[k].valorTotalVenta)
                this.descripcion = val[k].descripcion
                this.turnos.turno =  Number(val[k].turno )
                const turn: Turnos = {
                  domiciliosAddGruposProductosContenidoDescuentoInventarioUuid: val[k].Uuid,
                  companiasId: Number(val[k].companiasId),
                  clientesId: Number(val[k].clientesId),
                  usuariosId: Number(val[k].usuariosId),
                  estado: val[k].estado,
                  turno: Number(val[k].turno),
                  cantidad: Number(val[k].cantidad),
                  fecha: val[k].fecha,
                  domicilio: val[k].domicilio,
                  codigo: val[k].codigo,
                  numeroPedido: Number(val[k].numeromesa),
                  fechaInicio: null,
                  fechaFin:null,
                  fechaSelect: null,
                  gruposReservasPorProductoId:"",
                  mesasId:0,
                  productosElaboradosId:"",
                  nombre: "",
                  valorImpuesto: 0,
                  valorProducto:0,
                  porcentajeImpuesto: 0
                  };
                  this.store.dispatch(new UnsetTurnosAction());
                  this.store.dispatch(new SetTurnosAction(turn));
                  this.cargarClienteRedux(val[k].clientesId,val[k].nombreCompleto);
                  this.cargarUsuarioRedux( val[k].usuariosId, val[k].nombreUsuario)
                }
            }
            this.setupSubscription(this.listaProductosSeleccionados);
            this.listaProductosSeleccionados[0][""] = 1
            this.unificarProductosGestionadosLista()
            this.realizandoUnaVenta = true
            this.actualizando = true
            this.buscarNombreTurno()
          } else {
            if (this.turnos.numeroPedido === null) {
              this.turnosArray[0]['numeroPedidoMostrar'] = '';
            }
            this.buscarNombreTurno()
          }
        }, error => {
          this.listaProductosSeleccionados = []
        })
    })

  }

  cargarClienteRedux(clientesId:any, nombre: any) {
    this.clienteId.push({value:clientesId, display:nombre})
    let cliente: valueDisplay[] = [{
      value:clientesId,
      display:nombre
    }]
    const actionClienteCaja = new fromClienteSelect.CargarValueDisplaySuccessActions(cliente);
    this.store.dispatch(actionClienteCaja);
    this.valoresCliente = nombre;
  }

  cargarUsuarioRedux(usuarioId:any, nombre: any) {
    this.usuarioId.push({value:usuarioId, display:nombre})
    let usuario: valueDisplay[] = [{
      value:usuarioId,
      display:nombre
    }]
    const actionUsuario = new fromUsuarioSelect.CargarValueDisplaySuccessActions(usuario);
    this.store.dispatch(actionUsuario);
    this.valoresUsuario = nombre;
  }

  mostrarMensajeDeError(mensaje) {
  }
  filtrarProductos(item) {
    this.filtroGruposActivo = true
    this.nombreFiltroGrupo = item.nombreGrupoProducto
    this.filtrogruposProductosId = item.gruposProductosId
  }
  disminuirUnProducto(item, index) {
    let existeProductoSelecionado = this.listaProductosSeleccionados.filter((values)=> values.productosId == item.productosId)
    if(existeProductoSelecionado.length == 0) {
      this.utilsMensajero.mensajeMuestro('Advertencia','Debe agregar un producto primero para poder quitarlo luego','Advertencia')
      return
    }
    let nuevaCantidad = Number(existeProductoSelecionado[0].cantidad) - 1
    if (nuevaCantidad <= 0) {
      if (item['Uuid'] !== undefined) {
        this.utilsMensajero.mensajeMuestro('Advertencia','El registro no se puede quitar verifique','Advertencia')
        return
      } else {
        if(this.listaProductosSeleccionados.length === 0) {
            this.utilsMensajero.mensajeMuestro('Advertencia','Debe agregar un producto primero para poder quitarlo luego','Advertencia')
            return false;
        }
        index = this.devolverIndex(item)
        this.listaProductosSeleccionados.splice(index[0].index, 1)
        this.calcularValorTotalVenta(item, index,false)

        if (this.listaProductosSeleccionados.length <= 0) {
          this.realizandoUnaVenta = false
          this.actualizando = false
        }
      }



    } else {
      index = this.devolverIndex(item)
      this.actualizarReal(item, index[0].index)
      this.listaProductosSeleccionados[index[0].index]['cantidad'] = nuevaCantidad
    }

    this.valorTotalVenta = this.valorTotalVenta - item['valorVenta']
    this.valorTotalProductos = this.valorTotalProductos - item['valorProducto']
    this.valorTotalImpuestos = this.valorTotalImpuestos - item['valorImpuesto']
    if(this.CheckPorcentajeServicio){
      this.cambiarCheckPorcentaje()
    }
  }

  calcularValorTotalVenta(item: any, indexActual: any, queHago: boolean) {
    if(this.listaProductosSeleccionados.length> 0) {
      let valorTotalVentaJson: any = this.listaProductosSeleccionados.map((items: any, index: number) => {
        return {
            valorTotalVenta: Number(items.valorVenta) * Number(items.cantidad),
            valorGestionado: items.index === indexActual ? Number(items.valorVenta) : 0
            }
      })
    let valorTotalVenta = Object.keys(valorTotalVentaJson).map(function(key) {
        return valorTotalVentaJson[key].valorTotalVenta;
    });
    let valorTotalVentaReduce = valorTotalVenta.reduce((previous, current) => previous + current, 0);
    if(queHago) {
      this.valorTotalVenta = valorTotalVentaReduce
    }
      // let valorGestionadoFilter = valorTotalVentaJson.filter((item) => item.valorGestionado > 0 )
      // else {
      //   this.valorTotalVenta = valorTotalVentaReduce - valorGestionadoFilter[0].valorGestionado
      // }
    }
  }

  aumentarUnProductoSinExistencia(item, index) {
    // if(this.turnos.numeroPedido !== 0 && this.turnos.numeroPedido !== null){
      if(this.sobreGiroEnLosProductos) {
        let existenciasActuales = Number(item.existenciasActuales)
        let cantidadActual = 0
        let nuevaCantidadProductos = this.listaProductosSeleccionados.filter((value)=> value.productosId == item.productosId)
        if(nuevaCantidadProductos.length>0) {item['cantidad']
          cantidadActual = nuevaCantidadProductos[0].cantidad
          cantidadActual = cantidadActual + 1
        } else {
          cantidadActual = item['cantidad'] !== undefined ? Number(item['cantidad']): 1
          cantidadActual = item['cantidad'] === undefined  ? 1 : cantidadActual + 1
        }

        if(existenciasActuales<=0 || existenciasActuales < cantidadActual) {
          this.utilsMensajero.mensajeMuestro('Producto sin existencia','El producto no tiene existencias para vender','warning')
          return
        }
      }
    if(this.turnos.turno !== 0 && this.turnos.turno !== null){
      this.aumentarUnProducto(item, index)
    } else {
      this.utilsMensajero.mensajeMuestro('Advertencia','Debe seleccionar una mesa para poder continuar','Advertencia')
      return
    }
  }

  disminuirUnProductoSinExistencia(item, index) {
    let nuevaCantidad = 0
    if(item['cantidad'] == undefined){
      item['cantidad'] = 0
      nuevaCantidad = item['cantidad']
    } else {
      nuevaCantidad = Number(item['cantidad']) - 1
    }

    if(nuevaCantidad <= 0 && this.turnos.turno !== 0 && this.turnos.turno == null){
      this.utilsMensajero.mensajeMuestro('Advertencia','Debe agregar el producto para poder quitarlo jajaj','Advertencia')
      return
    } else {
      this.disminuirUnProducto(item, index)
    }
  }

  reproducir () {


    let audio = new Audio();

    audio.src = '../../assets/sonido.mp3'

    audio.load();
    audio.play();

    setTimeout(() => {

    }, 2 * 1000);
  }

  aumentarUnProducto(item, index) {
    if(this.sobreGiroEnLosProductos) {
      let existenciasActuales = Number(item.existenciasActuales)
      let cantidadActual = 0
      let nuevaCantidadProductos = this.listaProductosSeleccionados.filter((value)=> value.productosId == item.productosId)
      if(nuevaCantidadProductos.length>0) {item['cantidad']
        cantidadActual = nuevaCantidadProductos[0].cantidad
        cantidadActual = cantidadActual + 1
      } else {
        cantidadActual = item['cantidad'] !== undefined ? Number(item['cantidad']): 1
        cantidadActual = item['cantidad'] === undefined  ? 1 : cantidadActual + 1
      }

      if(existenciasActuales<=0 || existenciasActuales < cantidadActual) {
        this.utilsMensajero.mensajeMuestro('Producto sin existencia','El producto no tiene existencias para vender','warning')
        return
      }
    }
    let nuevaCantidad = Number(item['cantidad']) + 1
    let insertUpdate: any
    nuevaCantidad = isNaN(nuevaCantidad) === true ? 1 : nuevaCantidad
    let existeProductoSelecionado = this.listaProductosSeleccionados.filter((values)=> values.productosId == item.productosId)
    nuevaCantidad = existeProductoSelecionado.length > 0 ? existeProductoSelecionado[0].cantidad + 1 : 1
    let agregoAlCarrito: boolean = false;
    let existeElProducto = item['Uuid'] !== undefined;

    if(!existeElProducto){
      agregoAlCarrito = true;
      nuevaCantidad = 1;
      insertUpdate = this.agregarAlCarritoProductoExistente(item)
    } else {
      if(this.listaProductosSeleccionados.length === 0) {
        if(this.turnos.turno !== 0 && this.turnos.turno !== null){
          agregoAlCarrito = true;
          this.agregarAlCarrito(item)
        } else {
          this.utilsMensajero.mensajeMuestro('Advertencia','Debe seleccionar una mesa para poder continuar','Advertencia')
          return
        }
      } else {
        let id = Number(item['productosId'])
        let existe = this.listaProductosSeleccionados.filter((item) => item.productosId == id)
        if(existe.length == 0) {
          if(this.turnos.turno !== 0 && this.turnos.turno !== null){
            agregoAlCarrito = true;
            this.agregarAlCarrito(item)
          } else {
          this.utilsMensajero.mensajeMuestro('Advertencia','Debe seleccionar una mesa para poder continuar','Advertencia')
          return
          }
        } else {
          agregoAlCarrito = true;
          nuevaCantidad = 1;
          insertUpdate = this.agregarAlCarritoProductoExistente(item)
        }
      }
    }


    let existe = this.devolverIndex(item)
    index = existe.length == 0 ? 0 : existe[0].index
    if(insertUpdate.insertUpdate) {
      this.listaProductosSeleccionados[index]['cantidad'] = Number(insertUpdate.nuevaCantidad)
    }

    this.listaProductosSeleccionados[index]['numeroPedido'] = this.turnos.numeroPedido
    this.listaProductosSeleccionados[index]['turno'] = this.turnos.turno
    if(!agregoAlCarrito) {
      this.calcularValorTotalVenta(item, index,true)
    }
    this.actualizarReal(item, index)
    if(this.CheckPorcentajeServicio){
      this.cambiarCheckPorcentaje()
    }
  }

  devolverIndex(item) {
    let existe = []
    for(let i =0; i < this.listaProductosSeleccionados.length;i++) {
      if(item['productosId'] == this.listaProductosSeleccionados[i].productosId) {
        existe.push(this.listaProductosSeleccionados[i])
        existe[0].index = i
      }
    }
    return existe
  }

  actualizarReal(item: any, index: any) {
    let id = Number(item['productosId'])
    let tipoProducto = item['tipoProducto']
    for (let i = 0; i < this.listaProductos.length; i++) {
      if (this.listaProductos[i].productosId == id && this.listaProductos[i].tipoProducto == tipoProducto) {
        this.listaProductosSeleccionados[index]['valorImpuesto'] = this.listaProductos[i]['valorImpuesto'] == undefined ? 0 : this.listaProductos[i]['valorImpuesto']
        this.listaProductosSeleccionados[index]['valorProducto'] = this.listaProductos[i]['valorProducto'] == undefined ? 0 : this.listaProductos[i]['valorProducto']
        this.listaProductosSeleccionados[index]['queHago'] = true
        i = this.listaProductos.length + 1
      }
    }
  }

  unificarProductosGestionados(listaUnificar: any) {
    const groupedProducts = listaUnificar.reduce((acc, curr) => {
      const key = `${curr.productosId}-${curr.tipoProducto}-${curr.estadoGestion}`;
      if (!acc[key]) {
          acc[key] = { ...curr, cantidad: curr.cantidad };
      } else {
          acc[key].cantidad += curr.cantidad;
      }
      return acc;
  }, {});

  const resultadoArray = Object.keys(groupedProducts).map(key => groupedProducts[key]);
  return resultadoArray;
  }

  unificarProductosGestionadosLista() {
    const groupedProducts = this.listaProductosSeleccionados.reduce((acc, curr) => {
      const key = `${curr.productosId}-${curr.tipoProducto}-${curr.estadoGestion}`;
      if (!acc[key]) {
          acc[key] = { ...curr, cantidad: curr.cantidad };
      } else {
          acc[key].cantidad += curr.cantidad;
      }
      return acc;
  }, {});

  const resultadoArray = Object.keys(groupedProducts).map(key => groupedProducts[key]);
  this.listaProductosSeleccionados = resultadoArray;
  }

  agregarAlCarritoProductoExistente(item): any {
    this.realizandoUnaVenta = true
    let nuevaCantidad: number = 1
    let insertUpdate: boolean = false
    let productosId = item['productosId']

    let tipoProducto = item['tipoProducto']

    let contarProductosConElMismoId = this.listaProductosSeleccionados.filter(item => item.productosId === productosId && item.tipoProducto === tipoProducto)
    if (contarProductosConElMismoId.length>0) {

      let existeElProducto = contarProductosConElMismoId.filter(item => item.productosId === productosId && item.tipoProducto === tipoProducto && item.agregado === 1)

      if(existeElProducto.length>0) {
        if(existeElProducto.length> 1 || (existeElProducto[0].comandasId !== undefined && existeElProducto[0].estadoGestion !== "1")) {
          this.listaProductosSeleccionados.forEach((elemento, indice) => {
            elemento["indice"] = indice;
          });
          let existeProductoUnificado = this.unificarProductosGestionados(existeElProducto)
          if(existeProductoUnificado.length === 1) {
            let centroDeCostosGestionId =  item['centroDeCostosGestionId']
            let existeGestion = this.listaCentroDeCostosGestion.filter(item => item.centroDeCostosGestionId === centroDeCostosGestionId)
            if(existeGestion.length> 0) {
              let existeGestionCambiarEstado = this.listaCentroDeCostosGestion.filter(item => item.centroDeCostosId === existeGestion[0].centroDeCostosId && (item.gestionar === "0" || item.gestionar === null || item.gestionar === undefined))
              if(existeGestionCambiarEstado.length>0){
                if(item.estadoGestion === "0") {
                  this.listaProductosSeleccionados[item.indice]['cantidad'] = Number(this.listaProductosSeleccionados[item.indice]['cantidad']) + 1
                  this.listaProductosSeleccionados[item.indice]['numeroPedido'] = this.turnos.numeroPedido
                  this.listaProductosSeleccionados[item.indice]['turno'] = this.turnos.turno
                  nuevaCantidad = this.listaProductosSeleccionados[item.indice]['cantidad']
                  insertUpdate = true
                } else {
                  let nuevoItem = {...item}
                  nuevoItem['color'] = existeGestionCambiarEstado[0].color
                  nuevoItem['estadoGestion'] = "0"
                  nuevoItem['Uuid'] = undefined
                  nuevoItem['comandasId'] = undefined
                  nuevoItem['update'] = false
                  nuevoItem['cantidad'] = 1
                  insertUpdate = false
                  this.listaProductosSeleccionados.push(nuevoItem)
                }

              } else {
                insertUpdate = false
                this.listaProductosSeleccionados.push(item)
              }
            } else {
              insertUpdate = false
              this.listaProductosSeleccionados.push(item)
            }
          } else {
            let existeElProductoSeleccionNoGestion = existeElProducto.filter(item => item.productosId === productosId && item.tipoProducto === tipoProducto && item.agregado === 1 && (item.estadoGestion === "0" || item.estadoGestion === null || item.estadoGestion === undefined))
            let index = existeElProductoSeleccionNoGestion[0].indice
            this.listaProductosSeleccionados[index]['cantidad'] = Number(this.listaProductosSeleccionados[index]['cantidad']) + 1
            this.listaProductosSeleccionados[index]['numeroPedido'] = this.turnos.numeroPedido
            this.listaProductosSeleccionados[index]['turno'] = this.turnos.turno
            nuevaCantidad = this.listaProductosSeleccionados[index]['cantidad']
            insertUpdate = true
          }

        } else {
          let centroDeCostosGestionId =  item['centroDeCostosGestionId']
          let existeGestion = this.listaCentroDeCostosGestion.filter(item => item.centroDeCostosGestionId === centroDeCostosGestionId)
          if(existeGestion.length> 0) {
            let existeGestionCambiarEstado = this.listaCentroDeCostosGestion.filter(item => item.centroDeCostosId === existeGestion[0].centroDeCostosId && (item.gestionar === "0" || item.gestionar === null || item.gestionar === undefined))
            if(existeGestionCambiarEstado.length>0){
              let nuevoItem = {...item}
              nuevoItem['color'] = existeGestionCambiarEstado[0].color
              nuevoItem['estadoGestion'] = "0"
              nuevoItem['Uuid'] = undefined
              nuevoItem['comandasId'] = undefined
              nuevoItem['update'] = false
              nuevoItem['cantidad'] = 1
              insertUpdate = false
              this.listaProductosSeleccionados.push(nuevoItem)
            } else {
              insertUpdate = false
              this.listaProductosSeleccionados.push(item)
            }
          } else {
            insertUpdate = false
            item['cantidad'] = 1
            this.listaProductosSeleccionados.push(item)
          }
        }

      } else {
        let existeElProducto = contarProductosConElMismoId.filter(item => item.productosId === productosId && item.tipoProducto === tipoProducto)
        if(existeElProducto.length>0) {
          this.listaProductosSeleccionados.forEach((elemento, indice) => {
            elemento["indice"] = indice;
          });
          let existeElProductoSeleccionNoGestion = this.listaProductosSeleccionados.filter(item => item.productosId === productosId && item.tipoProducto === tipoProducto)
          let index = existeElProductoSeleccionNoGestion[0].indice
          this.listaProductosSeleccionados[index]['cantidad'] = Number(this.listaProductosSeleccionados[index]['cantidad']) + 1
          this.listaProductosSeleccionados[index]['numeroPedido'] = this.turnos.numeroPedido
          this.listaProductosSeleccionados[index]['turno'] = this.turnos.turno
          this.listaProductosSeleccionados[index]['estadoGestion'] ="0"
          nuevaCantidad = this.listaProductosSeleccionados[index]['cantidad']
          insertUpdate = true
        }  else {
          let centroDeCostosGestionId =  item['centroDeCostosGestionId']
          let existeGestion = this.listaCentroDeCostosGestion.filter(item => item.centroDeCostosGestionId === centroDeCostosGestionId)
          if(existeGestion.length> 0) {
            let existeGestionCambiarEstado = this.listaCentroDeCostosGestion.filter(item => item.centroDeCostosId === existeGestion[0].centroDeCostosId && (item.gestionar === "0" || item.gestionar === null || item.gestionar === undefined))
            if(existeGestionCambiarEstado.length>0){
              let nuevoItem = {...item}
              nuevoItem['color'] = existeGestionCambiarEstado[0].color
              nuevoItem['estadoGestion'] = "0"
              nuevoItem['Uuid'] = undefined
              nuevoItem['comandasId'] = undefined
              nuevoItem['update'] = false
              nuevoItem['cantidad'] = 1
              insertUpdate = false
              this.listaProductosSeleccionados.push(nuevoItem)
            } else {
              insertUpdate = false
              this.listaProductosSeleccionados.push(item)
            }
          } else {
            insertUpdate = false
            this.listaProductosSeleccionados.push(item)
          }
        }

      }
    } else {
      if(item['cantidad'] == undefined) {
        item['cantidad']
      }
      item['cantidad'] = 1
      insertUpdate = false
      this.listaProductosSeleccionados.push(item)
    }

    let valor = Number(item['valorVenta'])
    this.valorTotalVenta = this.valorTotalVenta + valor
    this.valorTotalProductos = this.valorTotalProductos + item['valorProducto']
    this.valorTotalImpuestos = this.valorTotalImpuestos + item['valorImpuesto']
    return {insertUpdate,nuevaCantidad}
  }

  procesarItem(item: any, listaCentroDeCostosGestion: any[], insertUpdate: boolean): boolean {
    let centroDeCostosGestionId =  item['centroDeCostosGestionId'];
    let existeGestion = listaCentroDeCostosGestion.filter(item => item.centroDeCostosGestionId === centroDeCostosGestionId);
    if(existeGestion.length > 0) {
      let existeGestionCambiarEstado = listaCentroDeCostosGestion.filter(item => item.centroDeCostosId === existeGestion[0].centroDeCostosId && (item.gestionar === "0" || item.gestionar === null || item.gestionar === undefined));
      if(existeGestionCambiarEstado.length > 0){
        let nuevoItem = { ...item };
        nuevoItem['color'] = existeGestionCambiarEstado[0].color;
        nuevoItem['estadoGestion'] = "0";
        nuevoItem['Uuid'] = undefined;
        nuevoItem['comandasId'] = undefined;
        nuevoItem['update'] = false;
        nuevoItem['cantidad'] = 1;
        insertUpdate = false;
        this.listaProductosSeleccionados.push(nuevoItem);
      } else {
        insertUpdate = false;
        this.listaProductosSeleccionados.push(item);
      }
    }
    return insertUpdate
  }

  agregarAlCarrito(item) {
    this.realizandoUnaVenta = true
    let productosId = item['productosId']

    let tipoProducto = item['tipoProducto']
    let contarProductosConElMismoId = this.listaProductosSeleccionados.filter(item => item.productosId === productosId && item.tipoProducto === tipoProducto)
    if (contarProductosConElMismoId.length > 0) {
      return
    }

    if(item['cantidad'] == undefined) {
      item['cantidad']
    }
    item['cantidad'] = 1
    this.listaProductosSeleccionados.push(item)

    let valor = Number(item['valorVenta'])
    this.valorTotalVenta = this.valorTotalVenta + valor
    this.valorTotalProductos = this.valorTotalProductos + item['valorProducto']
    this.valorTotalImpuestos = this.valorTotalImpuestos + item['valorImpuesto']
  }
  quitarFiltroGrupos() {
    this.filtroGruposActivo = false,
      this.filtrogruposProductosId = undefined
    this.nombreFiltroGrupo = ''
  }
  DECIMAL_SEPARATOR = '.'
  GROUP_SEPARATOR = ','

  format(valString) {
    if (!valString) {
      this.valorTotalDevolver = 0
      return '';
    }
    let val = valString.toString();
    try {
      this.valorTotalDevolver = Number(val.replace(/,/g, ''))
    } catch (e) {
      this.valorTotalDevolver = 0
    }

    const parts = this.unFormat(val).split(this.DECIMAL_SEPARATOR);
    return parts[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, this.GROUP_SEPARATOR) + (!parts[1] ? '' : this.DECIMAL_SEPARATOR + parts[1]);
  };

  unFormat(val) {
    if (!val) {
      return '';
    }
    val = val.replace(/^0+/, '');

    if (this.GROUP_SEPARATOR === ',') {
      return val.replace(/,/g, '');
    } else {
      return val.replace(/\./g, '');
    }
  };

  seleccionarTodo(ev) {
    if (ev && ev['target'] && ev.target['select']) {
      ev.target.select();
    }
  }

  limpiar() {
    this.listaProductosSeleccionados = []
    this.valorTotalVenta = 0
    this.valorTotalProductos = 0
    this.valorTotalImpuestos = 0
    this.realizandoUnaVenta = false
    this.valorTotalDevolver = 0
    // this.clienteId = []
    // this.clienteGenerico = undefined
    this.price = 0
    // this.listaGruposProductos = []
    // this.listaProductos = []
    // this.clienteGenericoMesa = []
    this.actualizando = false
    this.mesaCambio = []
    this.cargando = false;
    this.botonDeshabilitado = false;
    this.buscar = '';
    this.valoresCliente = ""
    this.mesaSeleccionada = ""
    this.formaPagoSeleccionada = 'O'
    this.CheckPorcentajeServicio = false
  }
  getMultiple(keys: string[]) {
    const promises = [];

    keys.forEach(key => promises.push(this.storage.get(key)));

    return Promise.all(promises).then(values => {
      const result = {};

      values.map((value, index) => {
        result[keys[index]] = value;
      });

      return result;
    });
  }

  public requestAutocompleteItems = (text: string): Observable<Response> => {
    return this.servicio.buscarClientesPorCompania(text)
  };
  public onTextChange(text) {
  }

  private newMethod(): any {
    return 'Debe ingresar el cliente';
  }

editarComanda(item: any, index){

  item['queHago'] = "A",
    item['nombreTabla'] = "comandas"
  item['name'] = "dataDynamicCrud"
  item['color'] = "#000132"
  item['estado'] = "G"
  item['descripcion'] = this.descripcion != undefined || this.descripcion !== "" ? this.descripcion : item['descripcion']

  let id = item['comandasId']

  this.servicio.buscarComandasPorId(id).subscribe((val) => {

    let cantidad = item['cantidad']
    let cantidadReal = 0
    cantidadReal = Number(val[0].cantidad)
    if (cantidad > cantidadReal) {
      this.listaProductosSeleccionados[index]['cantidad'] = cantidad
      let valorImpuesto = Number(val[0].valorImpuesto) / cantidadReal
      let valorVenta = Number(val[0].valorVenta)
      valorVenta = valorVenta - valorImpuesto

      this.valorTotalImpuestos = valorImpuesto * cantidad
      item['valorImpuesto'] = this.valorTotalImpuestos
      item['valorProducto'] = valorVenta * cantidad
      item['valorTotalVenta'] = this.valorTotalVenta
      this.valorTotalImpuestos = 0
      this.valorTotalVenta = 0
      this.listaProductosSeleccionados = []
    } else {
      if (cantidad <= 0) {
        this.listaProductosSeleccionados.splice(index, 1)

        if (this.listaProductosSeleccionados.length <= 0) {
          this.realizandoUnaVenta = false
          this.actualizando = false
        }
      } else {
        this.listaProductosSeleccionados[index]['cantidad'] = cantidad
      }
      this.listaProductosSeleccionados[index]['cantidad'] = cantidad
      let valorImpuesto = Number(val[0].valorImpuesto) / cantidadReal
      let valorVenta = Number(val[0].valorVenta)
      valorVenta = valorVenta - valorImpuesto

      this.valorTotalImpuestos = valorImpuesto * cantidad
      item['valorImpuesto'] = this.valorTotalImpuestos
      item['valorProducto'] = valorVenta * cantidad
      item['valorTotalVenta'] = this.valorTotalVenta
      this.valorTotalImpuestos = 0
      this.valorTotalVenta = 0
      this.listaProductosSeleccionados = []
    }

    this.servicio.actualizarComandas(item).subscribe((val) => {
      let id = Number(val['_body'])
      this.actualizarValoresDesdePedidos('','true')
    })

  })

}

cancelarComanda(item: any){

  item['queHago'] = "A",
    item['nombreTabla'] = "comandas",
    item['name'] = "dataDynamicCrud"


  this.numeromesa = item.numeromesa
  let numeromesa = this.numeromesa
  let codigo = item.codigo
  let mensaje = `Salón ${numeromesa} código comanda ${codigo}`
  let val = item['companiasId']

  this.servicio.cancelarComandasPorCompanias(item, val).subscribe(() => {
    this.traerDatosGuardados(this.numeromesa)
    this.limpiar()
  })

}
formatearCadena(cadena){
  let valorinicial = cadena.length
  let primero, segundo, ultimo
  primero = cadena.substr(0, 4)
  segundo = cadena.substr(5, 2)
  ultimo = cadena.substr(valorinicial - 2, valorinicial)
  if (valorinicial != 10) {
    let recorrer = cadena.split('-')
    for (var i = 0; i < recorrer.length; i++) {
      if (i == 1 && recorrer[i].length == 1) {
        segundo = `0${recorrer[i]}`
      }
      if (i == 2 && recorrer[i].length == 1) {
        ultimo = `0${recorrer[i]}`
      }
    }
  }
  return `${primero}-${ultimo}-${segundo}`
}

cerrarSession(){
  this.auth.logout()
  this.navCtrl.setRoot('LoginPage');
}

buscarIdMesaActualizar(idmesa: any){

  let data = []

  let valorComparar = Number(idmesa)
  for (let k = 0; k < this.mesaCambio.length; k++) {
    if (k === valorComparar) {
      data.push({
        id: this.mesaCambio[k].mesas,
      })

    }
  }

  return data

}

actualizarMesa(mesasIdMesaCambio?:any){

  let numeromesa = this.numeromesa
  let mesas = this.buscarIdMesaActualizar(numeromesa)
  this.storage.get('companiasId').then((val) => {
    let idmesanueva = this.mesaCambio[mesasIdMesaCambio].mesas
    this.servicio.trasladarMesaPorCompaniaDomicilios(numeromesa, idmesanueva, val, this.turnosArray[0].turno)
      .subscribe((val) => {
        this.listaProductosSeleccionados = []
        this.buscarDatos()
        this.estadoGestionPedidos = false
      }, (error) => {
        this.estadoGestionPedidos = false
        console.log(error)
      })
  })

}

buscarMesaPorId(item: any ) {
  this.mesasId = item.detail.value
}

async llamarModal(botonaceptar:any, botondenegar:any, titulo:any,cerrar:any) {
  const modal = await this.modalControllers.create({
    component: MensajerosMensajerosPage,
    componentProps: {
      botonaceptar,
      botondenegar,
      titulo,
      cerrar
    }
  });
  return modal
}
async eliminarMesa(){
  const uuids = this.listaProductosSeleccionados[0]['Uuid']
  const val = await this.storage.get('companiasId');
  this.utilsMensajero.mensajeConfirmacionDos('Borrar','¿Está Seguro de borrar los registros de el pedido?','question','Si','No')
  .then((borrar: boolean) => {
   if (borrar) {
      this.servicio.eliminarComandasPorCompanias(uuids, val).subscribe(() => {
      this.listaProductosSeleccionados = []
      this.buscarDatos()
    })
   }else {
    this.utilsMensajero.mensajeMuestro('Borrar','No se elimiron los registros','Advertencia')
   }
 })
}

printC(item: any, imagenes: boolean, canvas: boolean): void {

  let codigo = 0
  let queImprimo = 0
  codigo =  item.codigo
  if(codigo=== undefined) {
  codigo = item.factura
  queImprimo = 1
}


this.storage.get('companiasId').then((companiasId) => {
  this.servicio.imprimirComandaBlue(codigo, companiasId)

    .subscribe((data) => {
      this.modalPrintCualquieraBlu(data)
    })
})

}

modalPrintCualquieraBlu(item: any){

  this.guardarBlu(item)
}

guardarBlu(item: any){
}

imprimirC(item: any) {
  const url = URL_SERVICIOS_LOCALES;
  const datos = {
    nombre: JSON.stringify(item)
  }
}

descargarArchivoAndroid(data:any){

  let item = data

 let modal = this.modalControllers.create(ImpresoraBluePage,{item})
  modal.present();

  modal.onDidDismiss(data => {
    this.limpiar()
    this.buscarDatos()
    if (data) {
      data.name = ""
      }
  })

}

async descargarArchivo(datos: any) {
  const item = datos;
  const modal = await this.modalControllers.create({
    component: ImpresoraBluePage,
    componentProps: {
      item
    }
  });
 modal.present();

  modal.onDidDismiss(data => {
    if (data) {
      this.limpiar()
      this.buscarDatos()
    }
  })

}

reemprimirReciboMesasGestion(valorImpresora:any) {

  for (let posicion: any = 0; posicion < valorImpresora.length; posicion++) {

    let recibo = ''
    // if (mensaje && mensaje[0] && mensaje[0][0]) {
      const mensajes = valorImpresora[posicion]

      // for (let index: any = 0; index < mensajes.length; index++) {
      //   recibo += mensajes[index]['reciboCaja'] + '\n'
      // }
      for (let index:any = 0; index < mensajes.length; index++) {
        //recibo +=  '   ' + mensaje[index]['reciboCaja'] + '\n'
        const textoRecibo = mensajes[index]['reciboCaja'];

        // Comandos ESC/POS para negrita y tamaño de fuente
        const negritaOn = '\x1b\x45\x01'; // Activar negrita
        const negritaOff = '\x1b\x45\x00'; // Desactivar negrita
        const tamañoGrandeNotanto = '\x1b\x21\x10'; // Cambiar a tamaño de fuente grande
        const tamañoGrande = '\x1b\x21\x20'; // Cambiar a tamaño de fuente grande
        const tamañoNormal = '\x1b\x21\x00'; // Cambiar a tamaño de fuente normal

        if (textoRecibo.includes("TOTAL A PAGAR")) {
          recibo += negritaOn + tamañoGrande + '   ' + textoRecibo + '\n' + tamañoNormal + negritaOff;
        } else {
          if(textoRecibo.includes("CAMBIO")) {
            recibo += negritaOn + tamañoGrandeNotanto + '   ' + textoRecibo + '\n' + tamañoNormal + negritaOff;
          } else {
            recibo += '   ' + textoRecibo + '\n';
          }
        }
      }
    // }

    this.servicio.imprimirRecibo(recibo).subscribe(
      res => {
        console.log(res)
      },
      err => {
        console.log(err)

      }
    )


  }

}

reemprimirRecibo(mensaje) {
  let recibo = ''
  if (mensaje && mensaje[0] && mensaje[0][0]) {
    const mensajes = mensaje[0]

    // for (let index: any = 0; index < mensajes.length; index++) {
    //   recibo += mensajes[index]['reciboCaja'] + '\n'
    // }
    for (let index:any = 0; index < mensajes.length; index++) {
      //recibo +=  '   ' + mensaje[index]['reciboCaja'] + '\n'
      const textoRecibo = mensajes[index]['reciboCaja'];

      // Comandos ESC/POS para negrita y tamaño de fuente
      const negritaOn = '\x1b\x45\x01'; // Activar negrita
      const negritaOff = '\x1b\x45\x00'; // Desactivar negrita
      const tamañoGrandeNotanto = '\x1b\x21\x10'; // Cambiar a tamaño de fuente grande
      const tamañoGrande = '\x1b\x21\x20'; // Cambiar a tamaño de fuente grande
      const tamañoNormal = '\x1b\x21\x00'; // Cambiar a tamaño de fuente normal

      if (textoRecibo.includes("TOTAL A PAGAR")) {
        recibo += negritaOn + tamañoGrande + '   ' + textoRecibo + '\n' + tamañoNormal + negritaOff;
      } else {
        if(textoRecibo.includes("CAMBIO")) {
          recibo += negritaOn + tamañoGrandeNotanto + '   ' + textoRecibo + '\n' + tamañoNormal + negritaOff;
        } else {
          recibo += '   ' + textoRecibo + '\n';
        }
      }
    }
  }

  this.servicio.imprimirRecibo(recibo).subscribe(
    res => {
      console.log(res)
    },
    err => {
      console.log(err)

    }
  )
}
printD(item: any, imagenes: boolean, canvas: boolean): void {
  let codigo = 0
  let queImprimo = 0

  codigo =  item.codigo
  // tslint:disable-next-line: align
  if(codigo=== undefined) {
    codigo = item.factura
    queImprimo = 1
  }

  this.storage.get('companiasId').then((companiasId) => {
  this.servicio.imprimirComandaBlueafn(codigo, companiasId)
      .subscribe((items: any) => {

        this.descargarArchivo(items)
      }, (error)=> {
        ;
  });
})
}

  onEvent(event: string, item: any){
    if (event === 'onTextChange') {

     let valor = this.getItems(this.buscar);
     if(valor){
          item = valor
    }
    }
    }

    onEventafn(event: any){
      this.agregarAlCarrito(event)
    }
    onEventafn2(event: any){
    }
    getItems(event: any): void {
        if(!this.allItems){
          let valores = this.listaProductos
          this.allItems = valores;
        }
        this.listaProductos = this.allItems.filter((item) => {
          return item.nombreProducto.toLowerCase().indexOf(this.buscar.toLowerCase()) > -1;
        });

        }

       async generarPago() {
          const listaProductosSeleccionados = this.listaProductosSeleccionados;
          this.storage.set('generarVenta',false);
          this.enviarcomanda(true)
          const existeTurno = await this.validarExisteTurno()
          const modal = await this.modalControllers.create({
            component: PagoPage,
            componentProps: {
              item: listaProductosSeleccionados,
              clienteId: this.clienteId
            }
          });
          await modal.present();
          let venta = await this.storage.get('generarVenta');
          modal.onDidDismiss(data => {
            if( data === false && venta === false) {
              this.traerDatosTurnos();
            } else {
              this.limpiar()
              this.turnos = undefined;
              this.turnosArray = [];
              this.actualizar['valor'] = true;
              this.traerDatosTurnos();
            }
          })
        }

    async mostrarDinamica(items: any) {
      const modal = await this.modalControllers.create({
        component: DinamicaPage,
        componentProps: {
          item: items
        }
      });
      await modal.present();
      modal.onDidDismiss(data => {
      })
      this.limpiar();
      this.buscarDatos();
    }



    async irAdinamicaGruposPorProductos() {
      const modal = await this.modalControllers.create({
        component: DinamicaGruposPorProductosPage,
        componentProps: {
          item: []
        }
      });
      await modal.present();
      modal.onDidDismiss(data => {})
    }

    irAmenuPrincipal() {
      this.iab.create(`http://138.121.170.105:8300/#/home`,'_system');
    }

    irAcerrarSesion() {
        this.auth.logout();
        // this.navCtrl.setRoot('login');
        this.navCtrl.push('LoginPage');
    }
    async asignarTurno() {
      this.mesaSeleccionada = ""
      this.limpiarCliente()
      this.limpiarUsuario()
      this.asignarNuevoTurno()
    };

    limpiarCliente() {
      this.formaPagoSeleccionada = 'O'
      this.CheckPorcentajeServicio = false
      const actionClienteCaja = new fromClienteSelect.CargarValueDisplaySuccessActions([]);
      this.store.dispatch(actionClienteCaja);
      this.valoresCliente = '';
    }

    limpiarUsuario() {
      const actionUsuarioCaja = new fromUsuarioSelect.CargarValueDisplaySuccessActions([]);
      this.store.dispatch(actionUsuarioCaja);
      this.valoresUsuario = '';
    }

    async asignarNuevoTurno() {
      this.domicilioCheck = false
      this.actualizar['valor'] = false;
      this.domicilio = 'N';
      this.descripcion = '';
      this.listaProductosSeleccionados = []
      this.valorTotalVenta = 0
      this.valorTotalProductos = 0
      this.valorTotalImpuestos = 0
      this.realizandoUnaVenta = true
      this.valorTotalDevolver = 0
      this.clienteId = []
      this.clienteGenerico = undefined
      this.price = 0
      this.clienteGenericoMesa = []
      this.mesaCambio = []
      this.cargando = false;
      this.botonDeshabilitado = false;
      this.buscar = '';
      this.pedidoVacio()
      this.cargarTurno(this.companiasId, this.usuariosid, 1, '');
      if(this.gruposProductosId.length === 0)  {
        let gestionPedidos: any = await this.utilsGestionPedidosRedux.buscarGruposProductosGestionPedidosStore()
        if(gestionPedidos.gestionPedidos === undefined){
          this.cargarGruposIniciales(this.companiasId)
        } else {
          this.listaGruposProductos = gestionPedidos.gestionpedidos[0]
          this.listaProductos = gestionPedidos.gestionpedidos[1]
          this.clienteGenericoMesa = gestionPedidos.gestionpedidos[2]
          this.listaClientes = gestionPedidos.gestionpedidos[2]
        }
      }
      this.mesasId = undefined;
      this.listaMuestra = [];
      this.buscarDatos(0);
    };
    async cancelar() {
      this.utilsMensajero.mensajeConfirmacionDos('Limpiar datos','¿Está Seguro de Limpiar los datos ?','question','Si','No')
      .then((limpiardatos: boolean) => {
       if (limpiardatos) {
           this.listaProductosSeleccionados = []
          this.descripcion = '';
          this.domicilio = 'N';
          this.domicilioCheck = false;
          this.pedidoVacio();
          this.store.dispatch(new UnsetTurnosAction());
          this.valorTotalVenta = 0;
          this.cargarTurno(this.companiasId, this.usuariosid, 1, '');
          this.actualizarValoresDesdePedidos('', 'true')
       }
     })
    }


    cargarTurno(companiasId: any, usuariosid: any, clienteId: any, descripcion: any) {
      this.servicio.getComandasVacio(this.companiasId, this.usuariosid, clienteId, descripcion)
      .subscribe( (items: any) => {
        if(NUBE_AWS) {
          let valoresTurnos = JSON.parse(items['_body'])
          this.turnos = new Turnos(valoresTurnos.data[0][0])
        } else {
          this.turnos =  new Turnos(items[0][0]);
        }
        this.turnosArray = [];
        this.turnosArray.push(this.turnos);
        if (this.turnos.numeroPedido === null) {
          this.turnosArray[0]['numeroPedidoMostrar'] = '';
        }
        this.nombreTurno = !this.actualizar.valor ?  "# Turno " + this.turnosArray[0].turno : 'Asignar turno'
        this.store.dispatch(new UnsetTurnosAction())
        this.store.dispatch(new SetTurnosAction(this.turnos));
        let listaMuestra = this.listaMuestra
        this.listaMuestra = []
        this.listaMuestra = listaMuestra
       }, (error) => {
        console.log(error);
      });
    }

    traerDatosTurnos() {
          let turno = isNaN(this.turnos.turno) === true ? 1 :  this.turnos.turno
          this.servicio.buscarComandasturnoPorCompania(turno,this.companiasId)
          .subscribe((val: any)=>{
            this.listaProductosSeleccionados = []
            let entrarDatos = false;
            let dataJson = NUBE_AWS ? JSON.parse(val['_body']) : val
            let dataResponse = NUBE_AWS ? dataJson.data : val
            val = dataResponse
            if(val.length>0 && val[0].length>0) {
              this.realizandoUnaVenta = true
              this.actualizando = true
              this.actualizar['valor'] = false;
              this.domicilio = val[0][0].domicilio;
              if (this.domicilio === 'S' && !this.domicilioCheck) {
                this.domicilioCheck = !this.domicilioCheck;
              } else {
                if (this.domicilio === 'N' && this.domicilioCheck) {
                  this.domicilioCheck = !this.domicilioCheck;
                }
              }
              for(var k = 0;k < val[0].length;k++){
                  this.listaProductosSeleccionados.push(val[0][k])
                  this.valorTotalImpuestos += Number(val[0][k].valorImpuesto)
                  this.valorTotalVenta += Number(val[0][k].valorTotalVenta)
                  this.valorTotalProductos+= Number(val[0][k].valorProducto)
                  this.valorTotalDevolver = Number(val[0][k].valorTotalVenta)
                  this.valorTotalVenta = Number(val[0][k].valorTotalVenta)
                  this.numeromesa = Number(val[0][k].numeromesa)
                  this.actualizarReal(val[0][k],k)
                  this.turnos.turno = Number(val[0][k].turno)
                  this.descripcion = val[0][k].descripcion



            }
            entrarDatos = true
            if(val[0].length > 0 ) {
              let turnos: Turnos = {
                turno : val[0][0].turno,
                estado : val[0][0].estado,
                usuariosId : val[0][0].usuariosId,
                clientesId : val[0][0].clientesId,
                companiasId : val[0][0].companiasId,
                domiciliosAddGruposProductosContenidoDescuentoInventarioUuid : val[0][0].Uuid,
                numeroPedido : null,
                codigo: val[0][0].codigo,
                domicilio : val[0][0].domicilio,
                fecha : val[0][0].fecha,
                cantidad : val[0][0].cantidad,
                fechaInicio: null,
                fechaFin:null,
                fechaSelect: null,
                gruposReservasPorProductoId:"",
                mesasId:0,
                productosElaboradosId:"",
                nombre: "",
                valorImpuesto: 0,
                valorProducto:0,
                porcentajeImpuesto: 0
              }
              this.store.dispatch(new UnsetTurnosAction())
              this.store.dispatch(new SetTurnosAction(turnos));
              this.cargarClienteRedux(val[0][0].clientesId,val[0][0].nombreCompleto)
              this.cargarUsuarioRedux( val[0][0].usuariosId, val[0][0].nombreUsuario)
              if(val[0][0].incluirServicio === 'S'){
                this.cambiarCheckPorcentaje()
              }
            }
            }
            this.unificarProductosGestionadosLista()
            if(!entrarDatos) {
              this.actualizar['valor'] = false;
              this.actualizarValoresDesdeMesas('','false')
            } else {
                this.actualizar['valor'] = false;
                this.buscarGrupos();
            }
            this.buscarNombreTurno()
          })
    }
    buscarComandasTurnosUnico() {
      this.servicio.buscarComandasMesero(this.turnos.turno, this.companiasId)
      .subscribe((val: any) => {
        this.listaProductosSeleccionados = []
        if (val.length > 0) {
          for (let k = 0; k < val.length; k++) {
              this.listaProductosSeleccionados.push(val[k])
              this.valorTotalImpuestos += Number(val[k].valorImpuesto)
              this.valorTotalVenta += Number(val[k].valorTotalVenta)
              this.valorTotalProductos += Number(val[k].valorProducto)
              this.valorTotalDevolver = Number(val[k].valorTotalVenta)
              this.valorTotalVenta = Number(val[k].valorTotalVenta)
              this.descripcion = val[k].descripcion
              this.turnos.turno =  Number(val[k].turno )
          }
          this.realizandoUnaVenta = true
          this.actualizando = true
        } else {
          if (this.turnos.numeroPedido === null) {
            this.turnosArray[0]['numeroPedidoMostrar'] = '';
          }
        }
      }, error => {
        this.listaProductosSeleccionados = []
      })
    }

    async buscarGrupos() {
      let gestionPedidos: any = await this.utilsGestionPedidosRedux.buscarGruposProductosGestionPedidosStore()
      if (gestionPedidos && Array.isArray(gestionPedidos.gestionpedidos) && gestionPedidos.gestionpedidos.length === 0) {
        this.cargarGruposIniciales(this.companiasId)
      } else {
      this.listaGruposProductos = gestionPedidos.gestionpedidos[0]
      this.listaProductos = gestionPedidos.gestionpedidos[1]
      this.clienteGenericoMesa = gestionPedidos.gestionpedidos[2]
      this.listaClientes = gestionPedidos.gestionpedidos[2]
      }
    }

    buscarUsuarioPorEmpresaDomicilios() {
      this.storage.get('companiasId').then((val) => {
        this.servicio.buscarUsuarioPorEmpresaDomicilios(val).subscribe(
          (res: any) => {
            this.usuarioSelect = res[0];
          },
          err => {
            this.mostrarMensajeDeError('No se puedieron traer los usuario, intente luego.')
          }
        )
      })
    }

    async mostrarTurnos() {
      let modal = this.modalControllers.create(TurnosPage,{},
         {
          cssClass: 'fullscreen-modal',
          enableBackdropDismiss: true
        }
      )
      modal.present();
      modal.onDidDismiss(data => {
        if (data !== null && data !== undefined && data.turno !== undefined) {
          this.turnos.turno = Number(data.turno);
          this.descripcion = '';
          if (data.numeromesa !== "") {
            this.mesaSeleccionada = data.numeromesa
          }
          this.traerDatosTurnos();
        }
      })
    }

    async mostrarDevolverVentas() {
      const modal = await this.modalControllers.create({
        component: DevolverVentaPage,
        componentProps: {
          bluetooth: this.bluetooth,
          manejaImpresoPorDefecto: this.manejaImpresoPorDefecto,
          devolverVenta: this.devolverVenta
        }
       });
      await modal.present();
      modal.onDidDismiss(data => {})
    }

    async validarAsignacionDePedido(pedido: any, id: any) {

  let item: any = await this.utilsTurnosRedux.buscarTurnosStore()

  let numeroPedido = null
  let turno = null
  if(NUBE_AWS) {
    numeroPedido = item === undefined ? null : item.turnos.numeroPedido
    turno = item === undefined ? 0 : item.turnos.turno
  } else {
    numeroPedido = item.turnos.numeroPedido;
    turno = item.turnos.turno;
  }
  if ( numeroPedido === null &&
      this.listaMuestra[id] !== undefined &&
      !this.listaMuestra[id].sinAsignar) {
        this.storage.get('companiasId').then((val) => {
          if( val ) {
            this.servicioMesas.ActualizarComandasSinPedido(val, turno, pedido)
            .subscribe( ( item: any) => {
              let items = NUBE_AWS ? item.data[0] :item[0][0]
              if( items.length !== 0 ) {
                const data = items;
                this.llenarTurnoRedux(data);
              } else {
                //console.log('asignar un nuevo turno y anclarlo a el pedido')
                this.servicio.getComandasVacio(this.companiasId, 0, 0, '').subscribe((item: any)=> {
                    let items = Number(pedido);
                    if(NUBE_AWS) {
                      let valuesJson = JSON.parse(item['_body'])
                      let valuesData = valuesJson.data[0][0]
                      valuesData.numeromesa = items
                      this.llenarTurnoRedux(valuesData);
                    } else {
                      item[0][0].numeromesa = items
                      const data = item[0][0];
                      this.llenarTurnoRedux(data);
                    }
                }, (error) => {
                  console.log(error)
                });
              }
              this.sacarMensajeBoton(pedido,'false','N',-1);
            })
          }
        });
      } else {
        if ( numeroPedido !== null && this.listaMuestra[id] !== undefined && !this.listaMuestra[id].sinAsignar ) {
          this.cargarTurno(this.companiasId, this.usuariosid, this.clienteId, '');
        }
      }
}

    pedidoVacio() {
      this.numeromesa = undefined;
    }

    llenarTurnoRedux(data: any) {
      const turn: Turnos = {
        domiciliosAddGruposProductosContenidoDescuentoInventarioUuid: data.Uuid,
        companiasId: Number(data.companiasId),
        clientesId: Number(data.clientesId),
        usuariosId: Number(data.usuariosId),
        estado: data.estado,
        turno: Number(data.turno),
        cantidad: Number(data.cantidad),
        fecha: data.fecha,
        domicilio: data.domicilio,
        codigo: data.codigo,
        numeroPedido: Number(data.numeromesa),
        fechaInicio:null,
        fechaFin:null,
        fechaSelect: null,
        gruposReservasPorProductoId:"",
        mesasId:0,
        productosElaboradosId:"",
        nombre: "",
        valorImpuesto: 0,
        valorProducto:0,
        porcentajeImpuesto: 0
        };
      this.store.dispatch(new UnsetTurnosAction())
      this.store.dispatch(new SetTurnosAction(turn));
    }
    cambiarCheckDomicilio() {
      this.domicilioCheck = !this.domicilioCheck
      if (this.domicilioCheck) {
        this.domicilio = 'S'
      } else {
        this.domicilio = 'N';
      }
    }
    cambiarCheckDomicilioFinal() {
      this.domicilioCheck = !this.domicilioCheck
    }
    print(item:any,imagen:boolean,canvas:boolean): void {
      this.storage.get('companiasId').then((companiasId)=>{
          this.imprimirDataCualquiera(item,companiasId)
      })
  }
  imprimirDataCualquiera(mensaje:any,companiasId:any){

    let codigo = 0
    let queImprimo = 0
    codigo =  mensaje.codigo
    if(codigo===undefined){
    codigo =  mensaje.factura
    queImprimo = 1
    }
    let val = companiasId
    let valores

    this.servicio.buscarParametrosGenerales(val)
    .subscribe((data)=>{

    let imagen = ''
    if(NUBE_AWS) {
      imagen = JSON.parse(data['_body']).data[0][0].imagen
    } else {
      imagen = data[0].imagen
    }

    if(queImprimo==1){

        this.servicio.imprimirFactura(codigo,val)
        .subscribe((data)=>{

        let mensajeafn = JSON.parse(data['_body'])
        let mensajes = mensajeafn.data[0]

        let item = mensajes
        this.modalPrintCualquiera(item,imagen,codigo)

        },
    )
    }else{
    this.servicio.imprimirComandasMesas(codigo,val)
    .subscribe((data)=>{

        let mensajeafn = JSON.parse(data['_body'])
        let mensajes = mensajeafn.data[0]

        let item = mensajes
        this.modalPrintCualquiera(item,imagen,codigo)
    },
    )}

    })

}

imprimirParcial(){
  if(this.platform.is('android') || this.platform.is('ios')){
    if(this.listaProductosSeleccionados.length>0) {
      this.storage.get('companiasId').then((val) => {
        if( val ) {
          let codigo = this.listaProductosSeleccionados[0].codigo
          this.servicio.imprimirComandasMesasParcial(this.listaProductosSeleccionados,codigo,val)
          .subscribe( ( item: any) => {
            let items = NUBE_AWS ? JSON.parse(item['_body']) :item[0][0]
            if( items.data.length !== 0 ) {
              const data = items.data;
              this.modalPrintCualquieraBlutoothAndroid(data)
            }
          })
        }
      });
    }
  }else{
  if(this.listaProductosSeleccionados.length>0) {
    this.storage.get('companiasId').then((val) => {
      if( val ) {
        let codigo = this.listaProductosSeleccionados[0].codigo
        this.servicio.imprimirComandasMesasParcial(this.listaProductosSeleccionados,codigo,val)
        .subscribe( ( item: any) => {
          let items = NUBE_AWS ? JSON.parse(item['_body']) :item[0][0]
          if( items.data.length !== 0 ) {
            const data = items.data;
            this.reemprimirRecibo(data)
          }
        })
      }
    });
  }
 }
}
async modalPrintCualquiera(item:any,imagen:any,codigo:any){
  let modal = this.modalControllers.create(ImprimirPage,{ item, imagen,codigo})
  modal.present();

  modal.onDidDismiss(data => {
    if (data) {
      data.name = ""
      }
  })
  // const modal = await this.modalControllers.create({
  //   component: ImpresoraCualquieraComponentPage,
  //   componentProps: {
  //     item,
  //     imagen,
  //     codigo
  //   }
  // });
  // await modal.present();

  // modal.onDidDismiss(data => {
  //   if (data) {
  //     data.name = ""
  //   }
  // })
}

async validarExisteTurno() {
  this.servicio.buscarComandasturnoPorCompania(this.turnos.turno,this.companiasId)
  .subscribe((val: any)=>{
    this.listaProductosSeleccionados = []
    let entrarDatos = false;
    if(val.length>0) {
      this.realizandoUnaVenta = true
      this.actualizando = true
      this.actualizar['valor'] = false;
      this.domicilio = val[0].domicilio;
      if (this.domicilio === 'S' && !this.domicilioCheck) {
        this.domicilioCheck = !this.domicilioCheck;
      } else {
        if (this.domicilio === 'N' && this.domicilioCheck) {
          this.domicilioCheck = !this.domicilioCheck;
        }
      }
      for(var k = 0;k < val.length;k++){
          this.listaProductosSeleccionados.push(val[k])
          this.valorTotalImpuestos += Number(val[k].valorImpuesto)
          this.valorTotalVenta += Number(val[k].valorTotalVenta)
          this.valorTotalProductos+= Number(val[k].valorProducto)
          this.valorTotalDevolver = Number(val[k].valorTotalVenta)
          this.valorTotalVenta = Number(val[k].valorTotalVenta)
          this.numeromesa = Number(val[k].numeromesa)
          this.actualizarReal(val[k],k)
          this.turnos.turno = Number(val[k].turno)
          this.descripcion = val[k].descripcion


    }
    entrarDatos = true

    }
    if(!entrarDatos) {
      this.actualizar['valor'] = false;
      this.actualizarValoresDesdeMesas('','false')
    } else {
        this.actualizar['valor'] = false;
        this.buscarGrupos();
    }
  })
}
buscarTurnosAsignados() {
  this.storage.get('companiasId').then((val) => {
    if (val) {
      this.servicio.buscarComandasturnoPorCompaniaAsignados(val)
      .subscribe((items: any)=> {
        let dataJson = NUBE_AWS ? JSON.parse(items['_body']) : items
        let dataResponse = NUBE_AWS ? dataJson.data[0] : dataJson
        items = dataResponse
        for (let i = 0; i<items.length;i++) {
            this.turnosAsignados.push({
              turno: items[i].turno,
              numeromesa: items[i].numeromesa,
              codigo: items[i].codigo,
              domicilio: items[i].domicilio
            });
        }
        this.store.dispatch(new UnsetTurnosAsignadosAction());
        this.store.dispatch(new SetTurnosAsignadosAction(this.turnosAsignados));
        this.llenarTurnoAsignadosRedux()
      });
    }
  });
}
async llenarTurnoAsignadosRedux() {
  let lista: any = this.listaProductosSeleccionados.filter((item)=> item.turno == this.turnos.turno)
  if(lista.length < this.listaProductosSeleccionados.length) {
    this.enviarcomanda(true)
  }else {
    let listaActual: any = this.listaProductosSeleccionados
    if ( listaActual.length > 0) {
      this.store.dispatch(new manipularPedido(listaActual, this.turnosAsignados, this.turnos.turno))
    }
  }
}



async buscarUsuarioSelectPage() {

  this.actualizarestados(this.estado)
  const modal = await this.modalControllers.create(UsuarioSelectPage, {data: [],consultarUsuario: true});
  await modal.present();
  modal.onDidDismiss(data => {
    if (data != undefined && data.value != undefined) {
      this.usuarioId.push({value:data.value, display:data.display})
      let usuario: valueDisplay[] = [{
        value:data.value,
        display:data.display
      }]
      const actionUsuario = new fromUsuarioSelect.CargarValueDisplaySuccessActions(usuario);
      this.store.dispatch(actionUsuario);
      this.valoresUsuario = data.display;
    }
  })
}

async buscarClienteSelect() {
  this.estado = {
    clienteSelect: true,
    usuarioSelect: false,
    grupos: true,
    productos: false,
    pedidos: false,
    mesas: false,
    response: false
  }
  this.actualizarestados(this.estado)
  const modal = await this.modalControllers.create(ClienteSelectPage);
  await modal.present();
  modal.onDidDismiss(data => {
    this.estado = {
      clienteSelect: false,
      usuarioSelect: false,
      grupos: true,
      productos: false,
      pedidos: false,
      mesas: false,
      response: false
    }
    this.actualizarestados(this.estado)
    if (data) {
      this.clienteId.push({value:data.value, display:data.display})
      let cliente: valueDisplay[] = [{
        value:data.value,
        display:data.display
      }]
      const actionClienteCaja = new fromClienteSelect.CargarValueDisplaySuccessActions(cliente);
      this.store.dispatch(actionClienteCaja);
      this.valoresCliente = data.display;
    }
  })
}

async buscarUsuarioSelect() {
  this.estado = {
    clienteSelect: false,
    usuarioSelect: true,
    grupos: true,
    productos: false,
    pedidos: false,
    mesas: false,
    response: false
  }
  this.actualizarestados(this.estado)
  const modal = await this.modalControllers.create(ClienteSelectPage);
  await modal.present();
  modal.onDidDismiss(data => {
    this.estado = {
      clienteSelect: false,
      usuarioSelect: false,
      grupos: true,
      productos: false,
      pedidos: false,
      mesas: false,
      response: false
    }
    this.actualizarestados(this.estado)
    if (data) {
      // usuarioSelect = [afn afnarqui];
      // usuarioId = [];
      this.usuarioId.push({value:data.value, display:data.display})
      let usuario: valueDisplay[] = [{
        value:data.value,
        display:data.display
      }]
      const actionUsuario = new fromUsuarioSelect.CargarValueDisplaySuccessActions(usuario);
      this.store.dispatch(actionUsuario);
      this.valoresUsuario = data.display;
    }
  })
}

async buscarClienteStore() {
  return new Promise((resolve, reject) => {
     this.store.select('clienteSelect').subscribe((clienteSelect) => {
       let cliente = clienteSelect == undefined ? 1 : clienteSelect
       return resolve(cliente)
     })
   });
 }

 async cargarCliente(clientesId: any) {

  let clienteSelect: any = await this.buscarClienteStore();
  let dataClienteResponse = clienteSelect.valuedisplay.filter((item)=> item.value == clientesId)
  if(dataClienteResponse.length === 0) {
    return
  }
  this.clienteId.push({value:dataClienteResponse[0].value, display:dataClienteResponse[0].display})

  let cliente: valueDisplay[] = [{
    value:dataClienteResponse[0].value,
    display:dataClienteResponse[0].display
  }]
  const actionClienteCaja = new fromClienteSelect.CargarValueDisplaySuccessActions(cliente);
  this.store.dispatch(actionClienteCaja);
  this.valoresCliente = dataClienteResponse[0].nombreCliente;
 }


 resetStore() {
   const actionclienteSelect = new fromClienteSelect.CargarValueDisplaySuccessActions([]);
   this.store.dispatch(actionclienteSelect);
   this.clienteId = []
   this.valoresCliente = ""
 }

 buscarValorVenta() {
  let valorDevolver = 0
  if(this.listaProductosSeleccionados.length > 0) {
    // if(this.turnos.numeroPedido !== 0 && this.turnos.numeroPedido !== null){
      if(this.turnos.turno !== 0 && this.turnos.turno !== null){
      for(let i=0;i < this.listaProductosSeleccionados.length;i++ ){
        if(this.listaProductosSeleccionados[i].turno == this.turnos.turno) {
          valorDevolver+= this.listaProductosSeleccionados[i].cantidad * this.listaProductosSeleccionados[i].valorVenta
        }
      }
    }
  }
  return valorDevolver
 }

 async enviarcomanda(queHago: Boolean) {
  // queHago = si llega en undefined viene de enviar comanda si queHago es = true viene de generPago
  // esto va permitir guardar un turno antes de hacer el pago del mismo, lo que se busca es que si al hacer un pago
  // y le dan atrás el sistema deja los productos gestionados en el turno hasta el momento
  this.cargando = true;
  this.botonDeshabilitado = true;
  try {
      this.valorTotalVenta = this.buscarValorVenta();
    if ( this.valorTotalVenta === 0) {
      // this.limpiar()
      this.actualizarValoresDesdePedidos('','true')
      this.cargando = false;
      this.botonDeshabilitado = false;
      return
    } else {
      this.cargando = true;
    }
    this.realizandoUnaVenta = false
    if ( this.valorTotalVenta <= 0){
        this.mostrarMensajeDeError('Valor total venta no valido!')
        this.cargando = false;
        this.botonDeshabilitado = false;
        this.actualizarValoresDesdePedidos('','true')
        return
    }
    let datosAdicionales = {
        valorTotalVenta: this.valorTotalVenta,
        totalPagado: this.valorTotalDevolver,
        valorTotalDevolver: (this.valorTotalDevolver - this.valorTotalVenta),
    }

    let clienteSelect = await this.buscarClienteStore();
    let gestionPedidos: any = await this.utilsGestionPedidosRedux.buscarGruposProductosGestionPedidosStore()
    //this.clienteGenerico = gestionPedidos.gestionpedidos[2]
    if (gestionPedidos && gestionPedidos.gestionpedidos !== null && gestionPedidos.gestionpedidos[2] !== undefined) {
      this.clienteGenerico = gestionPedidos.gestionpedidos[2];
    } else {
      this.clienteGenerico = gestionPedidos !== null ? this.clienteGenerico : null;
    }
    let responseGetMultiple = await this.getMultiple(['usuariosId','companiasId']);
    let responseUsuarioSelect:any = await this.utilsRedux.buscarUsuarioSelectStore()
    if (this.domicilioCheck) {
      const usuarioId = this.usuarioId['usuariosId'] == undefined ? 1 : this.usuarioId['usuariosId']
      datosAdicionales['usuariosId'] = usuarioId;
      if (datosAdicionales['usuariosId'] === undefined) {
        datosAdicionales['usuariosId'] = this.usuarioId['usuariosId'];
      }
      if (datosAdicionales['usuariosId'] === undefined) {
        datosAdicionales['usuariosId'] = responseGetMultiple['usuariosId'];
      }
      if( datosAdicionales['usuariosId'] == 1 && responseUsuarioSelect.valuedisplay[0].value !== undefined) {
        datosAdicionales['usuariosId'] = responseUsuarioSelect.valuedisplay[0].value
      } else if(datosAdicionales['usuariosId'] == 1) {
        this.utilsMensajero.mensajeMuestro('Advertencia','Debe ingresar el usuario','Advertencia')
        this.cargando = false;
        this.botonDeshabilitado = false;
        this.actualizarValoresDesdePedidos('','true')
        return
      }
    } else {
      datosAdicionales['usuariosId'] = responseGetMultiple['usuariosId']
    }
    if(responseUsuarioSelect !== undefined && responseUsuarioSelect.valuedisplay !== undefined && responseUsuarioSelect.valuedisplay[0] !== undefined &&  responseUsuarioSelect.valuedisplay[0].value !== undefined ) {
      datosAdicionales['usuariosId'] = responseUsuarioSelect.valuedisplay[0].value
    }

    if(this.claveEnPedidosSalon) {
      datosAdicionales['usuariosId'] = localStorage.getItem('usuariosIdIngresoConClave')
    }

    datosAdicionales['companiasId'] = responseGetMultiple['companiasId'];
    if (this.clienteId && this.clienteId[0] && this.clienteId[0]['value']) {
        datosAdicionales['clientesId'] = clienteSelect['valuedisplay'][0].value
    } else if(this.clienteGenerico && this.clienteGenerico[0] && this.clienteGenerico[0]['clientesId']) {

        datosAdicionales['clientesId'] = this.clienteGenerico[0]['clientesId']
    } else {
        if (this.domicilioCheck) {
          const clienteId = this.clienteId['clientesId']
          datosAdicionales['clientesId'] = clienteId;
          if (datosAdicionales['clientesId'] === undefined) {
            datosAdicionales['clientesId'] = 1
          }
        } else {
          datosAdicionales['clientesId'] = 1
        }
    }

    if((datosAdicionales['clientesId'] == 0 || datosAdicionales['clientesId'] == 1) && this.domicilio =="S"){
      this.utilsMensajero.mensajeMuestro('Advertencia','Debe ingresar el cliente','Advertencia')
      this.cargando = false;
      this.botonDeshabilitado = false;
      this.actualizarValoresDesdePedidos('','true')
      return
    }

    let fechaHoy = new Date()
    let nuevafechaIngreso = fechaHoy.toLocaleDateString()
    nuevafechaIngreso = nuevafechaIngreso.split('/').reverse().join('-')
    let fecha = this.formatearCadena(nuevafechaIngreso)
    let uuids = uuid.v4();

    let nuevoArray = []
    if(this.listaProductosSeleccionados.length === 0) {
      this.mostrarMensajes('No ha seleccionado ningun producto','Verifique')
      this.cargando = false;
      this.botonDeshabilitado = false;
      this.actualizarValoresDesdePedidos('','true')
      return
    }
    for(var k =0;k < this.listaProductosSeleccionados.length;k++){
      this.listaProductosSeleccionados[k]['numeromesa'] = this.numeromesa
      this.listaProductosSeleccionados[k]['clientesId'] = datosAdicionales['clientesId']
      this.listaProductosSeleccionados[k]['companiasId'] = datosAdicionales['companiasId']
      this.listaProductosSeleccionados[k]['usuariosId'] = datosAdicionales['usuariosId']
      this.listaProductosSeleccionados[k]['valorTotalVenta'] = this.valorTotalVenta
      this.listaProductosSeleccionados[k]['totalPagado'] = 0
      this.listaProductosSeleccionados[k]['descripcion'] = this.listaProductosSeleccionados[k]['descripcion']
      this.listaProductosSeleccionados[k]['valorTotalDevolver'] = 0
      this.listaProductosSeleccionados[k]['fecha'] = fecha
      this.listaProductosSeleccionados[k]['domicilio'] = this.domicilio
      if(GESTION_PEDIDOS_SALON){
        this.listaProductosSeleccionados[k]['estado'] = this.listaProductosSeleccionados[k]['estado'] == undefined ? 'P' : this.listaProductosSeleccionados[k]['estado']
      }else{
        this.listaProductosSeleccionados[k]['estado'] = 'G'
      }
      this.listaProductosSeleccionados[k]['Uuid'] = uuids
      let nuevoCodigo = `${this.listaProductosSeleccionados[k]['Uuid'].substr(0,6)}-${this.listaProductosSeleccionados[k]['companiasId']}`;
      let Uuid = `${this.listaProductosSeleccionados[k]['Uuid'].substr(0,6)}-${datosAdicionales['companiasId']}`
      if(this.actualizando){
        Uuid = this.listaProductosSeleccionados[0]['codigo']
      }
      this.listaProductosSeleccionados[k]['codigo'] = Uuid
      if(this.listaProductosSeleccionados[k]['centroDeCostosId']=="0"){
        this.listaProductosSeleccionados[k]['centroDeCostosId'] = 0
      }

      if(this.listaProductosSeleccionados[k]['estadoGestion'] === undefined || this.listaProductosSeleccionados[k]['estadoGestion'] === null || this.listaProductosSeleccionados[k]['estadoGestion'] === "0") {
        // if(this.listaProductosSeleccionados[k]['tipoProducto'] === "E") {
        //   let existeGestion = this.listaCentroDeCostosGestion.filter(item => item.nombre === "COCINA" && item.gestionar == "0")
        //   if(existeGestion.length>0){
        //     this.listaProductosSeleccionados[k]['color'] = existeGestion[0].color
        //     this.listaProductosSeleccionados[k]['centroDeCostosGestionId'] =  existeGestion[0].centroDeCostosGestionId
        //   } else {
        //     this.listaProductosSeleccionados[k]['color'] = "#425D42"
        //     this.listaProductosSeleccionados[k]['centroDeCostosGestionId'] = 0
        //   }
        // } else {
          let centroDeCostosId =  this.listaProductosSeleccionados[k]['centroDeCostosId']
          let existeGestion = this.listaCentroDeCostosGestion.filter(item => item.centroDeCostosId == centroDeCostosId && item.gestionar == "0")
          if(existeGestion.length>0){
            this.listaProductosSeleccionados[k]['color'] = existeGestion[0].color
            this.listaProductosSeleccionados[k]['centroDeCostosGestionId'] =  existeGestion[0].centroDeCostosGestionId
          } else {
            this.listaProductosSeleccionados[k]['color'] = "#425D42"
            this.listaProductosSeleccionados[k]['centroDeCostosGestionId'] = 0
          }
        // }
      }

      if(this.listaProductosSeleccionados[k]['imagen']==null){
      this.listaProductosSeleccionados[k]['imagen']= "https://res.cloudinary.com/drqk6qzo7/image/upload/v1517108463/Sin_imagen_disponible_gsghfo.jpg"
    }
    console.log(this.listaProductosSeleccionados)

      let valorImpuesto = 0
      valorImpuesto = parseInt(this.listaProductosSeleccionados[k]['valorImpuesto'])
      // valorImpuesto = this.listaProductosSeleccionados[k]['queHago'] !== undefined ?
      // parseInt(this.listaProductosSeleccionados[k]['valorImpuesto']) * parseInt(this.listaProductosSeleccionados[k]['cantidad']) :
      // parseInt(this.listaProductosSeleccionados[k]['valorImpuesto'])
      let valorProducto = 0
      valorProducto = parseInt(this.listaProductosSeleccionados[k]['valorProducto'])
      // valorProducto = this.listaProductosSeleccionados[k]['queHago'] !== undefined ?
      // parseInt(this.listaProductosSeleccionados[k]['valorProducto']) * parseInt(this.listaProductosSeleccionados[k]['cantidad']) :
      // parseInt(this.listaProductosSeleccionados[k]['valorProducto'])
      let valorTotalVenta = parseInt(this.listaProductosSeleccionados[k]['valorVenta']) *  parseInt(this.listaProductosSeleccionados[k]['cantidad'])
      nuevoArray.push({
        'cantidad': parseInt(this.listaProductosSeleccionados[k]['cantidad']),
        'gruposProductosId': this.listaProductosSeleccionados[k]['gruposProductosId'],
        'imagen': this.listaProductosSeleccionados[k]['imagen'],
        'nombreProducto': this.listaProductosSeleccionados[k]['nombreProducto'],
        'numeromesa': this.listaProductosSeleccionados[k]['numeromesa'] == null || this.mesaSeleccionada == '' ? 200 : this.listaProductosSeleccionados[k]['numeromesa']  ,
        'productosId': this.listaProductosSeleccionados[k]['productosId'],
        'tipoProducto': this.listaProductosSeleccionados[k]['tipoProducto'],
        'valorImpuesto': valorImpuesto,
        'valorProducto': valorProducto,
        'valorVenta': parseInt(this.listaProductosSeleccionados[k]['valorVenta']),
        'clientesId': this.listaProductosSeleccionados[k]['clientesId'],
        'companiasId': this.listaProductosSeleccionados[k]['companiasId'],
        'totalPagado': this.listaProductosSeleccionados[k]['totalPagado'],
        'usuariosId': this.listaProductosSeleccionados[k]['usuariosId'],
        'valorTotalDevolver': this.listaProductosSeleccionados[k]['valorTotalDevolver'],
        'valorTotalVenta': valorTotalVenta,
        'centroDeCostosId': this.listaProductosSeleccionados[k]['centroDeCostosId'],
        'codigoCentroDeCosto': this.listaProductosSeleccionados[k]['codigoCentroDeCosto'],
        'fecha': this.listaProductosSeleccionados[k]['fecha'],
        'domicilio': this.listaProductosSeleccionados[k]['domicilio'],
        'estado': this.listaProductosSeleccionados[k]['estado'],
        'Uuid': this.listaProductosSeleccionados[k]['Uuid'],
        'codigo': this.listaProductosSeleccionados[k]['codigo'] === undefined ? nuevoCodigo : this.listaProductosSeleccionados[k]['codigo'],
        'color': this.listaProductosSeleccionados[k]['color'],
        'descripcion': this.listaProductosSeleccionados[k]['descripcion'],
        'turno': JSON.stringify(this.turnos.turno),
        'incluirServicio': this.CheckPorcentajeServicio ? 'S' : 'N',
        'formaDePago': this.formaPagoSeleccionada,
        'imprimirProducto': 1,// this.listaProductosSeleccionados[k]['imprimirProducto'],
        'imprimirGeneral': 1,//this.listaProductosSeleccionados[k]['imprimirGeneral'],
        'centroDeCostosGestionId': this.listaProductosSeleccionados[k]['centroDeCostosGestionId']
        })
    }


    const codigo = nuevoArray[0]['codigo']
    let descripcion = nuevoArray[0]['descripcion']
    this.descripcion = ''
    let dataGuardarComandasMesero = await this.servicio.guardarComandasMeseroPorCentroDeCosto(nuevoArray, codigo, descripcion).toPromise();
    this.cargando = false;
    this.botonDeshabilitado = false;
    let dataJson = NUBE_AWS ? JSON.parse(dataGuardarComandasMesero['_body']) : dataGuardarComandasMesero
    let dataResponse = NUBE_AWS ? dataJson.data : dataGuardarComandasMesero
    dataGuardarComandasMesero = dataResponse
    this.cargando = false;
    this.botonDeshabilitado = false;
    if(dataGuardarComandasMesero !== undefined &&
      dataGuardarComandasMesero[1] !== undefined &&
      dataGuardarComandasMesero[1].length > 0) {
         let listaActual: any =  dataGuardarComandasMesero[1]
        if (NUBE_AWS && this.turnosAsignados.length === 0) {
          this.mesaSeleccionada = ''
          this.mesaCambio = []
          this.mesasId;
          this.numeromesa;
          this.mesasIdMesaCambio;
            this.turnosAsignados.push({
              turno: dataGuardarComandasMesero[1][0].turno,
              numeromesa: dataGuardarComandasMesero[1][0].numeromesa,
              codigo: dataGuardarComandasMesero[1][0].codigo,
              domicilio: dataGuardarComandasMesero[1][0].domicilio
            })
            this.store.dispatch(new SetTurnosAsignadosAction(this.turnosAsignados));
            this.llenarTurnoAsignadosRedux()
          }
         this.store.dispatch(new manipularPedido(listaActual, this.turnosAsignados, this.turnos.turno))
         this.mesasId = undefined;
         this.listaMuestra = [];
         this.buscarDatos(0);
      }

    if(this.turnos !== undefined && this.turnos.turno !== 0 &&
      dataGuardarComandasMesero !== undefined &&
      dataGuardarComandasMesero[1] !== undefined &&
      dataGuardarComandasMesero[1].length > 0
      ){
      this.actualizarValoresDesdePedidos(Number(dataGuardarComandasMesero[1][0].numeromesa),'true',this.turnos.turno)
    } else {
      this.actualizarValoresDesdePedidos('','true')
    }
    } catch (error) {
      this.actualizarValoresDesdePedidos('','true')
      this.cargando = false;
      this.botonDeshabilitado = false;
      return
    }
    this.cargarTurno(this.companiasId, this.usuariosid, 1, '');
    this.listaProductosSeleccionados = [];
    this.mesasId = undefined
  }

  actualizarValoresDesdePedidos(id: any, queHago: string, numeroTurno?: number) {
    this.listaProductosSeleccionados = []
    // this.listaMuestra = [];
    this.listaMuestraOcupadas = [];
    if (id == 100) {
      this.numeromesa = id
      this.numeromesaMostrar = 'Domicilio'
    } else {
      this.numeromesa = id
      this.numeromesaMostrar = `Mesa # ${id}`
    }
    this.actualizar['valor'] = true
    this.limpiar()
    // this.buscarDatos(id)
  }


  actualizarValoresDesdeMesas(id: any, queHago: string, numeroTurno?: number) {
    this.listaProductosSeleccionados = []
    // this.listaMuestra = [];
    this.listaMuestraOcupadas = [];
    if (id == 100) {
      this.numeromesa = id
      this.numeromesaMostrar = 'Domicilio'
    } else {
      this.numeromesa = id
      this.numeromesaMostrar = `Mesa # ${id}`
    }
    this.actualizar['valor'] = false
    this.buscarGruposProductosParaCaja(id)
  }

  buscarDatoslocales(mesaGestionada?: number) {
    this.storage.get('companiasId').then((val) => {
      this.servicioMesas.buscarMesasPorCompania(val)
        .subscribe(
          (res: any) => {
            let dataJson = NUBE_AWS ? res.data : res
            res = dataJson
            if (res[0] !== undefined) {
            this.listaMuestra = [];
            for (var k = 0; k < res[0].length; k++) {
              this.listaMuestra.push({
                left: res[0][k].leftt,
                width: res[0][k].width,
                top: res[0][k].topp,
                height: res[0][k].height,
                id: res[0][k].id,
                color: '#d96153',
                Uuid: res[0][k].Uuid,
                name: 'dataDynamicCrud',
                queHago: 'I',
                nombreTabla: 'mesas',
                sinAsignar: false,
                colorOriginal:'#d96153',
                numeroPersona:res[0][k].numeroPersona,
                incluirServicio:res[0][k].incluirServicio,
                formaDePago:res[0][k].formaDePago
              });
              }
            }
            if (res[1] !== undefined) {
                for (var k = 0; k < res[1].length; k++) {
                  this.listaMuestra.push({
                    'left': res[1][k].leftt,
                    'width': res[1][k].width,
                    'top': res[1][k].topp,
                    'height': res[1][k].height,
                    'id': res[1][k].id,
                    'color':'#4e6b66',
                    'Uuid': res[1][k].Uuid,
                    'name': "dataDynamicCrud",
                    'queHago': "I",
                    'nombreTabla': "mesas",
                    sinAsignar: true,
                    'colorOriginal':'#4e6b66',
                    numeroPersona:res[1][k].numeroPersona,
                    incluirServicio:res[1][k].incluirServicio,
                    formaDePago:res[1][k].formaDePago
                  });
              }
            }
            //this.cargarTurno(val, this.usuariosid == undefined ? 1 : this.usuariosid, 1, '');
            },
        error => {
          }
        );
    })

    //this.listaProductosSeleccionados = []
    this.datatitle['valor'] = true
    this.domicilioCheck = false;
  }
  colorEstado() {
    return '#b61791'
  }


  actualizarItemSeleccion(item: string) {
    console.log('item', item)
  }

  async buscarNombreTurno() {
    let turnos: any = await this.utilsTurnosRedux.buscarTurnosStore()
    turnos.turnos.turno = turnos.turnos.turno == '200' ? '' : turnos.turnos.turno
    this.nombreTurno =  "# Turno " + turnos.turnos.turno
  }

  actualizarestados(estado: Estados) {
    let estados:any = {
      ...estado
    }
    let estadosAction = new fromEstados.SetEstadosAction(estados)
    this.store.dispatch(estadosAction)
  }

  llenarEstados(estado: Estados) {
    this.estado = {
      clienteSelect: estado.clienteSelect || false,
      usuarioSelect: estado.usuarioSelect || false,
      grupos: estado.grupos || true,
      productos: estado.productos || false,
      pedidos: estado.pedidos || false,
      mesas: estado.mesas || false,
      response: estado.response || false,
    }
  }
  gestionarPedido() {
    if(this.turnosArray[0].numerPedido == null && this.mesaSeleccionada !== '') {
      this.turnosArray[0].numerPedido = this.mesaSeleccionada
    }
    let modal = this.modalControllers.create(GestionarPedidoPage, {
      permiteEliminarPedido: this.permiteEliminarPedido,
      listaProductosSeleccionados:this.listaProductosSeleccionados,
      valorTotalVenta: this.valorTotalVenta,
      devolverVenta:this.devolverVenta,
      mesaCambio:this.mesaCambio,
      turnosArray: this.turnosArray,
      mesaSeleccionada:this.mesaSeleccionada,
      descripcion:this.descripcion
      }
      )
    modal.present();

    modal.onDidDismiss(data => {
      if (data) {
        let buscarDatos: boolean = false
        let imprimirParcialResponse: boolean = false
        for(let i = 0;i < data.length;i++) {
          if(data[i].name === 'formaPagoSeleccionada') {
            this.formaPagoSeleccionada = data[i].value
          }
          if(data[i].name === 'CheckPorcentajeServicio') {
            this.CheckPorcentajeServicio = data[i].value
          }
          if(data[i].name === 'buscarDatos') {
            buscarDatos = data[i].value
          }
          if(data[i].name === 'domicilioSeleccionada') {
            this.domicilio = data[i].value
            if(this.domicilio === 'S') {
              this.domicilioCheck = true
            }
          }
          if(data[i].name === 'descripcionVenta') {
            this.descripcion = data[i].value
          }
          if(data[i].name === 'clienteId') {
            this.clienteId = data[i].value
            if(data[i].value != undefined && data[i].value[0] != undefined && data[i].value[0].display != undefined) {
              this.valoresCliente = data[i].value[0].display
            }
          }
          if(data[i].name === 'usuarioId') {
            this.usuarioId = data[i].value
            if(data[i].value != undefined && data[i].value[0] != undefined && data[i].value[0].display != undefined) {
              this.valoresUsuario = data[i].value[0].display
            }
          }
          if(data[i].name === 'listaProductosSeleccionados') {
            let listaProductosSeleccionados = data[i].value
            this.listaProductosSeleccionados = []
            this.listaProductosSeleccionados.push(...listaProductosSeleccionados)
            if(this.listaProductosSeleccionados.length>0) {
              this.valorTotalVenta = this.listaProductosSeleccionados[0].valorTotalVenta
            }
          }
          if(data[i].name === 'imprimirGeneral') {
            this.listaProductosSeleccionados.forEach(elemento => {
              elemento.imprimirGeneral = data[i].value
            });
          }
          if(data[i].name === 'enviarComanda') {
            if(data[i].value) {
              this.enviarcomanda(undefined)
            }
          }
          if(data[i].name === 'imprimirParcial') {
            if(data[i].value) {
              imprimirParcialResponse = data[i].value
            }
          }
        }
        if(buscarDatos){
          this.cargarTurno(this.companiasId, this.usuariosid, 1, '');
          this.mesaSeleccionada = "";
          this.listaProductosSeleccionados = []
          this.limpiarCliente()
          this.limpiarUsuario()
          this.buscarDatos()
        }
        if(this.CheckPorcentajeServicio){
          this.cambiarCheckPorcentaje()
        }
        if(imprimirParcialResponse){
          this.imprimirParcial()
        }
      }
    })
  }

  cambiarCheckPorcentajeSubscription(listaProductosSeleccionados: any){



    let cantidad = listaProductosSeleccionados.length
    let valorProducto = 0
    let valorVenta = 0
    let valorImpuesto = 0
    listaProductosSeleccionados.forEach((data,item)=>{

      valorProducto+= data.valorVenta * data.cantidad
      valorVenta+= data.valorVenta
      valorImpuesto+= data.valorImpuesto * data.cantidad
      if(cantidad === item + 1){

        let porcentaje = valorProducto * 10 / 100
        let valorTotalServicio = porcentaje
        this.valorTotalVenta = valorProducto + valorImpuesto + valorTotalServicio
      }

    })

}

  cambiarCheckPorcentaje(){



    let cantidad = this.listaProductosSeleccionados.length
    let valorProducto = 0
    let valorVenta = 0
    let valorImpuesto = 0
    this.listaProductosSeleccionados.forEach((data,item)=>{

      valorProducto+= data.valorVenta * data.cantidad
      valorVenta+= data.valorVenta
      valorImpuesto+= data.valorImpuesto * data.cantidad
      if(cantidad === item + 1){

        let porcentaje = valorProducto * 10 / 100
        let valorTotalServicio = porcentaje
        this.valorTotalVenta = valorProducto + valorImpuesto + valorTotalServicio
      }

    })

}

  guardarClienteRapido(){

    let datosCliente: clientes = {
      tipoIdentificacion : 'C',
      identificacion : '0',
      digito : '0',
      fechaExpedicion : '',
      primerApellido : '',
      numeroTelefono : this.telefonoClienteRapido,
      segundoApellido : '',
      primerNombre : this.nombreClienteRapido,
      segundoNombre : '',
      nombreCompleto : this.nombreClienteRapido,
      fechaIngreso : '',
      estado : 'A',
      direccion : this.direccionClienteRapido,
      queHago: "I",
      nombreTabla: "clientes",
      name: "dataDynamicCrud"
    }
    this.storage.get('companiasId').then((val) => {
      datosCliente['companiasId']  = val
    this.providerClientes.guardar(datosCliente)
      .subscribe(
      res => {
        this.utilsMensajero.mensajeMuestro('CLIENTES','Guardado Exitosamente!','success')
        this.limpiarClienteRapido()
        this.buscarClientes()
        this.segId = 'products'
      },
      err => {
        console.log(err)}
      )
    })

  }

  limpiarClienteRapido(){

    this.telefonoClienteRapido = ""
    this.nombreClienteRapido = ""
    this.direccionClienteRapido = ""
    this.estadoFormCrearCliente = false

  }

  guardarProductoRapido(){

    if(this.codigoProducto !=="" && this.nombreProducto !== "" && this.codigoBarra !== "" && this.valorVenta !== 0){


    this.storage.get('companiasId').then((val) => {
    let datosProducto: any = {
        codigoProducto: this.codigoProducto,
        nombreProducto: this.nombreProducto,
        valorVenta: this.valorVenta,
        existenciasMinimas:0,
        existenciasActuales: 0,
        visualizaEnCaja: true,
        controlaEnInventario: true,
        tipoImpuesto:'I',
        valorImpuesto: this.valorImpuesto,
        centroDeCostosId: 1,
        imagen:'https://afnarqui.s3.us-east-1.amazonaws.com/sancolombia/sinimagen.png',
        codigoBarra:this.codigoBarra,
        companiasId:val,
        costo:this.costo,
        queHago: "I",
        nombreTabla: "productos",
        name: "dataDynamicCrud"
      }

      this.servicioProductos.guardarProducto(datosProducto)
      .subscribe(
        res => {

          this.utilsMensajero.mensajeMuestro('productos',"Producto guardado..","success")

            this.productoId =  JSON.parse(res['_body']).data.response[0][0].productosId
            this.guardarGruposProductos(this.productoId)
            this.limpiarProducto()
            this.buscarDatosIniciales()

            this.segId ="products"
        },
        err => {
            this.utilsMensajero.mensajeMuestro('productos',"No se pudo guardar el producto intente luego","advertencia")
            this.limpiarProductoRapido()
        }
      )
    // }

    })
}else{
    // this.mostrarMensajeAdvertencia('No se pudo guardar el producto existen campos obligatorios','Verifique')
    this.utilsMensajero.mensajeMuestro('productos',"No se pudo guardar el producto existen campos obligatorios","advertencia")
    this.limpiarProductoRapido()
}
}

limpiarProductoRapido(){

    this.codigoBarra =""
    this.nombreProducto = ""
    this.codigoProducto = ""
    this.valorVenta = 0
    this.costo = 0
    this.formState = 'collapsed'
    this.formStatebool = false
    this.productoId = ""
    this.cantidadRealCodigoBarra = 0
}
iniciarReconocimiento() {
  if (!this.reconocimientoActivo) {
    this.recognition = new webkitSpeechRecognition();
    this.recognition.onresult = (event) => {
      this.descripcion = event.results[0][0].transcript;
    };
    this.recognition.start();
    this.reconocimientoActivo = true;
    this.grabando = true;
  }
}

detenerReconocimiento() {
  if (this.reconocimientoActivo) {
    this.recognition.stop();
    this.reconocimientoActivo = false;
    this.grabando = false; // Establecer a false cuando se detiene la grabación
    // this.detenido = true; // Establecer a true cuando se detiene la grabación
  }
}
reemprimirComanda() {
  if(this.platform.is('android') || this.platform.is('ios')){
    if(this.listaProductosSeleccionados.length>0) {
      let codigo = this.listaProductosSeleccionados.length>0 ? this.listaProductosSeleccionados[0].codigo : this.listaProductosSeleccionados[0].factura
      this.imprimirAndroidMesero(codigo)
    }
  }else{
    if(this.listaProductosSeleccionados.length>0) {
      let item = {
        codigo: this.listaProductosSeleccionados[0].codigo,
        factura: this.listaProductosSeleccionados[0].factura
      }
      this.print(item, true,true)
    }
  }

}

gestionarPedidoPorProducto(item: any, i: any) {

  let modal = this.modalControllers.create(GestionporproductoPage, {
    permiteEliminarPedido: this.permiteEliminarPedido,
    listaProductosSeleccionados:this.listaProductosSeleccionados,
    valorTotalVenta: this.valorTotalVenta,
    devolverVenta:this.devolverVenta,
    mesaCambio:this.mesaCambio,
    turnosArray: this.turnosArray,
    mesaSeleccionada:this.mesaSeleccionada,
    descripcion:this.descripcion,
    item: item,
    i: i
    }
    )
  modal.present();

  modal.onDidDismiss(data => {
    if (data) {
      let comandaId = 0
      let indexOrComandaId = false
      let descripcion = ''
      for(let i = 0;i < data.length;i++) {
        if(data[i].name === 'listaProductosSeleccionados') {
          let listaProductos = data[i].value
          comandaId =  listaProductos[0].index === undefined ? listaProductos[0].comandasId : listaProductos[0].index
          indexOrComandaId = listaProductos[0].index === undefined ? true : false
        }
        if(data[i].name === 'descripcion') {
          descripcion = data[i].value
        }

      }
      if(indexOrComandaId) {
        let index = this.listaProductosSeleccionados.findIndex((item)=> item.comandasId == comandaId)
        this.listaProductosSeleccionados[index].descripcion = descripcion
      } else {
        this.listaProductosSeleccionados[comandaId].descripcion = descripcion
      }





    }
  })
}
// ionViewDidLoad() {
//   if(this.reserva) {
//     const element = document.getElementsByClassName('modal-wrapper')[0] as HTMLElement;
//     element.style.height = '100%';
//     element.style.width = '100%';
//     element.style.top = '0';
//     element.style.left = '0';
//     element.style.right = '0';
//     element.style.bottom = '0';
//   }
// }

ionViewDidLoad() {
  this.recargarValores()
  let datosGenerales = localStorage.getItem('datosGenerales')
  let datosGeneralesJSON = JSON.parse(datosGenerales)
  if(datosGeneralesJSON && datosGeneralesJSON["sobreGiroEnLosProductos"]) {
    this.sobreGiroEnLosProductos = datosGeneralesJSON["sobreGiroEnLosProductos"].seleccion === 'N' ? true : false
  }
  if(datosGeneralesJSON && datosGeneralesJSON["claveEnPedidosSalon"]) {
    this.claveEnPedidosSalon = datosGeneralesJSON["claveEnPedidosSalon"].seleccion === 'S' ? true : false
  }
  if(datosGeneralesJSON && datosGeneralesJSON["tiempoParaBloqueoClavePedidosSalon"]) {
    this.tiempoParaBloqueoClavePedidosSalon = datosGeneralesJSON["tiempoParaBloqueoClavePedidosSalon"]
  }
  if( this.claveEnPedidosSalon && !this.permiteIngresar) {
    localStorage.removeItem('usuariosIdIngresoConClave')
    this.abrirPagina('UsuarioPedidoSalonComponent','UsuarioPedidoSalonComponent')
    return
  }
  if(this.claveEnPedidosSalon) {
    localStorage.setItem('usuariosIdIngresoConClave',this.usuariosIdIngresoConClave)
    this.iniciarConteoInactividad();
  }
}

recargarValores(){
  this.servicioCompania.devolverVarios(['companiasId','usuariosId', 'nombreCargo'])
  .then(async (val)=>{
    if(val){
      let companiasId = val['companiasId'];
      let usuariosId = val['usuariosId'];
      let nombreUsuario = val['nombreUsuario'];
      this.utilsParametrosGeneralesRedux.buscarParametrosGeneralesRedux(companiasId, usuariosId, nombreUsuario)
      this.buscarParametrosGeneralesBD()
      this.cargarTurno(companiasId, usuariosId, 1, '');
      this.cargarGruposIniciales(companiasId)
      this.storage.get('nombreCargo').then((val) => {
        this.nombreCargoHeader = val
      });
      let buscarParametrosGeneralesStore: any = await this.utilsParametrosGeneralesRedux.buscarParametrosGeneralesStore()
      if(buscarParametrosGeneralesStore !== null && buscarParametrosGeneralesStore.parametrosGenerales !== null) {
        this.companiasId = buscarParametrosGeneralesStore.parametrosGenerales[0][0].companiasId
        this.usuariosid = buscarParametrosGeneralesStore.parametrosGenerales[0][0].usuariosid
        this.usuariosid == undefined ? usuariosId : this.usuariosid
        this.bluetooth = buscarParametrosGeneralesStore.parametrosGenerales[0][0].bluetooth
        this.manejaImpresoPorDefecto = buscarParametrosGeneralesStore.parametrosGenerales[0][0].manejaImpresoPorDefecto
        this.manejaCodigoDeBarras = buscarParametrosGeneralesStore.parametrosGenerales[0][0].manejaCodigoDeBarras
        this.creaProductoRapidoDesdeCaja = buscarParametrosGeneralesStore.parametrosGenerales[0][0].creaProductoRapidoDesdeCaja
        this.devolverVenta = buscarParametrosGeneralesStore.parametrosGenerales[0][0].devolverVenta
        this.nombreCompaniaHeader = buscarParametrosGeneralesStore.parametrosGenerales[0][0].nombreUsuario
        let administrador = buscarParametrosGeneralesStore.parametrosGenerales[1][0].administrador
        if (administrador){
          this.permiteEliminarPedido = true
        }
      }
    }


  })
}

async elect(){

  let resultado = this._electronService.ipcRenderer.sendSync('buscar-informacion-mododesconectado-listagruposproductos-caja',RUTA_MODO_DESCONECTADO)

  if(!resultado){
    }else {
          this.listaGruposProductos = resultado
      }


 let resultadolistaProductos = this._electronService.ipcRenderer.sendSync('buscar-informacion-mododesconectado-Productos-caja',RUTA_MODO_DESCONECTADO)

  if(!resultadolistaProductos){
  }else {
      this.listaProductos = resultadolistaProductos
  }


  let clienteGenerico = this._electronService.ipcRenderer.sendSync('buscar-informacion-mododesconectado-clienteGenerico',RUTA_MODO_DESCONECTADO)
  if(!clienteGenerico){
  }else {
      this.clienteGenericoMesa =JSON.parse(clienteGenerico)
  }

  let mesas = this._electronService.ipcRenderer.sendSync('buscar-informacion-mododesconectado-mesas',RUTA_MODO_DESCONECTADO)

  if(!mesas){
  }else {
    this.listaMuestra = []
    this.listaMuestra =JSON.parse(mesas)
  }

  let cliente = this._electronService.ipcRenderer.sendSync('buscar-informacion-mododesconectado-cliente',RUTA_MODO_DESCONECTADO)

  if(!cliente){
  }else {
      this.listaClientes =JSON.parse(cliente)
  }

  let centroDeCosto = this._electronService.ipcRenderer.sendSync('buscar-informacion-mododesconectado-CentroDeCostos',RUTA_MODO_DESCONECTADO)

  if(!centroDeCosto){
  }else {
    this.listaCentroDeCostosGestion =JSON.parse(centroDeCosto)
  }
}

async asignarNuevoTurnoDesconect() {
  this.domicilioCheck = false
  this.actualizar['valor'] = false;
  this.domicilio = 'N';
  this.descripcion = '';
  this.listaProductosSeleccionados = []
  this.valorTotalVenta = 0
  this.valorTotalProductos = 0
  this.valorTotalImpuestos = 0
  this.realizandoUnaVenta = true
  this.valorTotalDevolver = 0
  this.clienteId = []
  this.clienteGenerico = undefined
  this.price = 0
  this.clienteGenericoMesa = []
  this.mesaCambio = []
  this.cargando = false;
  this.botonDeshabilitado = false;
  this.buscar = '';
  this.pedidoVacio()
  this.cargarTurno(this.companiasId, this.usuariosid, 1, '');
  // if(this.gruposProductosId.length === 0)  {
  //   let gestionPedidos: any = await this.utilsGestionPedidosRedux.buscarGruposProductosGestionPedidosStore()
  //   if(gestionPedidos.gestionPedidos === undefined){
  //     this.cargarGruposIniciales(this.companiasId)
  //   } else {
  //     this.listaGruposProductos = gestionPedidos.gestionpedidos[0]
  //     this.listaProductos = gestionPedidos.gestionpedidos[1]
  //     this.clienteGenericoMesa = gestionPedidos.gestionpedidos[2]
  //     this.listaClientes = gestionPedidos.gestionpedidos[2]
  //   }
  // }
  this.mesasId = undefined;
  this.listaMuestra = [];
  // this.buscarDatos(0);
};

cargarTurnoDesconect(companiasId: any, usuariosid: any, clienteId: any, descripcion: any) {

  let resultado = this._electronService.ipcRenderer.sendSync('buscar-informacion-mododesconectado-comandas-vacias',RUTA_MODO_DESCONECTADO)

  if(!resultado){
  } else {
      this.turnos =  new Turnos(resultado[0]);
      this.turnosArray = [];
      this.turnosArray.push(this.turnos);
      if (this.turnos.numeroPedido === null) {
        this.turnosArray[0]['numeroPedidoMostrar'] = '';
      }
      this.nombreTurno = !this.actualizar.valor ?  "# Turno " + this.turnosArray[0].turno : 'Asignar turno'
      this.store.dispatch(new UnsetTurnosAction())
      this.store.dispatch(new SetTurnosAction(this.turnos));
      let listaMuestra = this.listaMuestra
      this.listaMuestra = []
      this.listaMuestra = listaMuestra
  }

  this.servicio.getComandasVacio(this.companiasId, this.usuariosid, clienteId, descripcion)
  .subscribe( (items: any) => {
    if(NUBE_AWS) {
      let valoresTurnos = JSON.parse(items['_body'])
      this.turnos = new Turnos(valoresTurnos.data[0][0])
    } else {
      this.turnos =  new Turnos(items[0][0]);
    }
    this.turnosArray = [];
    this.turnosArray.push(this.turnos);
    if (this.turnos.numeroPedido === null) {
      this.turnosArray[0]['numeroPedidoMostrar'] = '';
    }
    this.nombreTurno = !this.actualizar.valor ?  "# Turno " + this.turnosArray[0].turno : 'Asignar turno'
    this.store.dispatch(new UnsetTurnosAction())
    this.store.dispatch(new SetTurnosAction(this.turnos));
    let listaMuestra = this.listaMuestra
    this.listaMuestra = []
    this.listaMuestra = listaMuestra
   }, (error) => {
    console.log(error);
  });
}

async sacarMensajeBotonDesconect(id: any, queHago: string, domicilio: string, item: any) {
  this.descripcion = '';
  if(item.sinAsignar) {
    await this.validarAsignacionDePedidoDesconect(id,item);
  }

  // this.buscarMesasPorCompanias(id)
  // this.domicilio = domicilio;
  // this.actualizarValoresDesdeMesas(id, queHago,this.turnos.turno);
  // this.cambiarColorMesaSeleccionada(id)
}

async validarAsignacionDePedidoDesconect(pedido: any, id: any) {

  let item: any = await this.utilsTurnosRedux.buscarTurnosStore()

  let numeroPedido = null
  let turno = null
  if(NUBE_AWS) {
    numeroPedido = item === undefined ? null : item.turnos.numeroPedido
    turno = item === undefined ? 0 : item.turnos.turno
  } else {
    numeroPedido = item.turnos.numeroPedido;
    turno = item.turnos.turno;
  }
  if ( numeroPedido === null &&
      this.listaMuestra[id] !== undefined &&
      !this.listaMuestra[id].sinAsignar) {
        this.storage.get('companiasId').then((val) => {
          if( val ) {
            this.servicioMesas.ActualizarComandasSinPedido(val, turno, pedido)
            .subscribe( ( item: any) => {
              let items = NUBE_AWS ? item.data[0] :item[0][0]
              if( items.length !== 0 ) {
                const data = items;
                this.llenarTurnoRedux(data);
              } else {
                //console.log('asignar un nuevo turno y anclarlo a el pedido')
                this.servicio.getComandasVacio(this.companiasId, 0, 0, '').subscribe((item: any)=> {
                    let items = Number(pedido);
                    if(NUBE_AWS) {
                      let valuesJson = JSON.parse(item['_body'])
                      let valuesData = valuesJson.data[0][0]
                      valuesData.numeromesa = items
                      this.llenarTurnoRedux(valuesData);
                    } else {
                      item[0][0].numeromesa = items
                      const data = item[0][0];
                      this.llenarTurnoRedux(data);
                    }
                }, (error) => {
                  console.log(error)
                });
              }
              this.sacarMensajeBotonDesconect(pedido,'false','N',-1);
            })
          }
        });
      } else {
        if ( numeroPedido !== null && this.listaMuestra[id] !== undefined && !this.listaMuestra[id].sinAsignar ) {
          this.cargarTurnoDesconect(this.companiasId, this.usuariosid, this.clienteId, '');
        }
      }
}


imprimirGlobalMesero(codigo:any) {

  let popover = this.popoverCtrl.create(ImprimirGlobalComponent, { text: codigo,
    queHago:'imprimirMesero',
    cantidadImpresionesEnCaja: this.cantidadImpresionesEnCaja,
    ip:this.ip
  });
  popover.present({
    ev: codigo
  });

  popover.onDidDismiss((data) => {
    if (data) {

      console.log(data);
    }
  });
}

imprimirGlobalimprimirMeseroTodaLaFactura(codigo:any) {

  let popover = this.popoverCtrl.create(ImprimirGlobalComponent, { text: codigo,
    queHago:'imprimirMeseroTodaLaFactura',
    cantidadImpresionesEnCaja: this.cantidadImpresionesEnCaja,
    ip:this.ip
  });
  popover.present({
    ev: codigo
  });

  popover.onDidDismiss((data) => {
    if (data) {

      console.log(data);
    }
  });
}

abrirPagina(pagina:any,nombre:string){
  this.storage.get('rut').then((val)=>{
    this.recorrerVal = JSON.parse(val)
    let data = 0

    for(var i=0;i < this.recorrerVal.length;i++){
      if(this.recorrerVal[i].nombre == nombre){
        data = -1
      }
    }

    if(data!=-1){
      this.utilsMensajero.mensajeMuestro('Seguridad','No tiene permisos para ingresar. Verifique.', 'warning')
    }else{
      this.accesosDirectos(pagina)
    }

  })

}

  accesosDirectos(ruta:any) {
    switch(ruta){
      case "UsuarioPedidoSalonComponent":
      this.navCtrl.push(UsuarioPedidoSalonComponent)
      break;
    }
  }


  iniciarConteoInactividad() {
    if (this.actividadSub) {
      this.actividadSub.unsubscribe(); // Limpia suscripciones anteriores
    }

    console.log('🔄 Iniciando monitoreo de inactividad...');

    // 🔥 Detectar actividad con throttling para evitar demasiadas ejecuciones
    const actividad$ = merge(
      fromEvent(document, 'mousemove'),
      fromEvent(document, 'keydown'),
      fromEvent(document, 'touchstart')
    ).pipe(
      debounceTime(60000), // 🔥 Espera 1.5 segundos después del último evento antes de actuar
      distinctUntilChanged() // 🔥 Solo ejecuta si realmente hubo un cambio en la actividad
    );

    this.actividadSub = actividad$
      .pipe(
        switchMap(() => {
          console.log('⏳ Reiniciando el contador...');
          return timer(this.tiempoParaBloqueoClavePedidosSalon * 60000);
        })
      )
      .subscribe(() => {
        this.ngZone.run(() => {
          console.log('⏳ Tiempo de inactividad agotado, redirigiendo...');
          this.abrirPagina('UsuarioPedidoSalonComponent', 'UsuarioPedidoSalonComponent');
        });
      });
  }

  ngOnDestroy() {
    if (this.actividadSub) {
      this.actividadSub.unsubscribe(); // Evita fugas de memoria
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/meseromesero/meseromesero.ts